/* eslint-disable */
/**
 * 本文件由 scripts/gen-registry.mjs 自动生成，请勿手工修改。
 * 生成时间：2026/9/21 17:26:35
 * 覆盖页面：269 个（旧工程 html/ 下全部页面）
 *
 * meta 字段说明：
 *   title      菜单/页签标题
 *   legacyPath 旧页面地址，占位页与 iframe 过渡使用
 *   complexity 复杂度分档 A/B/C，用于排期
 *   migrated   是否已完成 Vue 迁移
 *   module     所属业务模块 key
 */
import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/index.vue'

/* ---------- 平台基础页面 ---------- */
export const rootRoutes: RouteRecordRaw[] = [
  {
    path: 'demo',
    name: 'RootDemo',
    component: () => import('@/views/common/LegacyFrame.vue'),
    meta: { title: '台账查询-按日汇总查询', legacyPath: '/hp-cloud/html/demo.html', complexity: 'A', migrated: true, quality: 'frame', module: '_root' }
  },
  {
    path: 'index',
    name: 'RootIndex',
    component: () => import('@/views/portal/index.vue'),
    meta: { title: '华鹏充电桩运营平台-首页', legacyPath: '/hp-cloud/html/index.html', complexity: 'B', migrated: true, quality: 'done', module: '_root' }
  },
  {
    path: 'login',
    name: 'RootLogin',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '华鹏充电桩运营平台-登录', legacyPath: '/hp-cloud/html/login.html', complexity: 'A', migrated: true, quality: 'done', module: '_root' }
  },
  {
    path: 'systemMaintenance',
    name: 'RootSystemMaintenance',
    component: () => import('@/views/common/LegacyFrame.vue'),
    meta: { title: '华鹏充电桩运营平台-登录', legacyPath: '/hp-cloud/html/systemMaintenance.html', complexity: 'A', migrated: false, quality: '', module: '_root' }
  },
]

/* ---------- 业务模块页面（按模块分组） ---------- */
export const moduleRoutes: RouteRecordRaw[] = [
  {
    path: '/sitemanage',
    name: 'SitemanageModule',
    component: Layout,
    redirect: '/sitemanage/anprDevice',
    meta: { title: '站点管理', module: 'sitemanage' },
    children: [
      {
        path: 'anprDevice',
        name: 'SitemanageAnprDevice',
        component: () => import('@/views/sitemanage/anprDevice.vue'),
        meta: { title: '站点管理 · anprDevice', legacyPath: '/hp-cloud/html/sitemanage/anprDevice.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'barCodeInit',
        name: 'SitemanageBarCodeInit',
        component: () => import('@/views/sitemanage/barCodeInit.vue'),
        meta: { title: '站点管理 · barCodeInit', legacyPath: '/hp-cloud/html/sitemanage/barCodeInit.html', complexity: 'A', migrated: true, quality: 'done', module: 'sitemanage' }
      },
      {
        path: 'baseadd',
        name: 'SitemanageBaseadd',
        component: () => import('@/views/sitemanage/baseadd.vue'),
        meta: { title: '站点管理 · 电桩ID', legacyPath: '/hp-cloud/html/sitemanage/baseadd.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'basetab',
        name: 'SitemanageBasetab',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '站点管理 · basetab', legacyPath: '/hp-cloud/html/sitemanage/basetab.html', complexity: 'C', migrated: true, quality: 'frame', module: 'sitemanage' }
      },
      {
        path: 'changeGroup',
        name: 'SitemanageChangeGroup',
        component: () => import('@/views/sitemanage/changeGroup.vue'),
        meta: { title: '站点管理 · 站点名称', legacyPath: '/hp-cloud/html/sitemanage/changeGroup.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'chargeSuccessStatistics',
        name: 'SitemanageChargeSuccessStatistics',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '站点管理 · chargeSuccessStatistics', legacyPath: '/hp-cloud/html/sitemanage/chargeSuccessStatistics.html', complexity: 'B', migrated: true, quality: 'frame', module: 'sitemanage' }
      },
      {
        path: 'chargingUser',
        name: 'SitemanageChargingUser',
        component: () => import('@/views/sitemanage/chargingUser.vue'),
        meta: { title: '站点管理 · 日期', legacyPath: '/hp-cloud/html/sitemanage/chargingUser.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'chooseShareprofit',
        name: 'SitemanageChooseShareprofit',
        component: () => import('@/views/sitemanage/chooseShareprofit.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/sitemanage/chooseShareprofit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'costAnalysis',
        name: 'SitemanageCostAnalysis',
        component: () => import('@/views/sitemanage/costAnalysis.vue'),
        meta: { title: '站点管理 · 日期', legacyPath: '/hp-cloud/html/sitemanage/costAnalysis.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'cpVoltageStatistics',
        name: 'SitemanageCpVoltageStatistics',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '站点管理 · cpVoltageStatistics', legacyPath: '/hp-cloud/html/sitemanage/cpVoltageStatistics.html', complexity: 'B', migrated: true, quality: 'frame', module: 'sitemanage' }
      },
      {
        path: 'editLockName',
        name: 'SitemanageEditLockName',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '站点管理 · editLockName', legacyPath: '/hp-cloud/html/sitemanage/editLockName.html', complexity: 'A', migrated: true, quality: 'frame', module: 'sitemanage' }
      },
      {
        path: 'gateway',
        name: 'SitemanageGateway',
        component: () => import('@/views/sitemanage/gateway.vue'),
        meta: { title: '站点管理 · 地锁名称', legacyPath: '/hp-cloud/html/sitemanage/gateway.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'groupLock',
        name: 'SitemanageGroupLock',
        component: () => import('@/views/sitemanage/groupLock.vue'),
        meta: { title: '站点管理 · 电桩ID', legacyPath: '/hp-cloud/html/sitemanage/groupLock.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'gunList',
        name: 'SitemanageGunList',
        component: () => import('@/views/sitemanage/gunList.vue'),
        meta: { title: '站点管理 · 电桩ID', legacyPath: '/hp-cloud/html/sitemanage/gunList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'heartJsonData',
        name: 'SitemanageHeartJsonData',
        component: () => import('@/views/sitemanage/heartJsonData.vue'),
        meta: { title: '故障履历', legacyPath: '/hp-cloud/html/sitemanage/heartJsonData.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'lookBase',
        name: 'SitemanageLookBase',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '站点管理 · lookBase', legacyPath: '/hp-cloud/html/sitemanage/lookBase.html', complexity: 'C', migrated: true, quality: 'frame', module: 'sitemanage' }
      },
      {
        path: 'lookBaseNew',
        name: 'SitemanageLookBaseNew',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '站点管理 · lookBaseNew', legacyPath: '/hp-cloud/html/sitemanage/lookBaseNew.html', complexity: 'A', migrated: false, quality: '', module: 'sitemanage' }
      },
      {
        path: 'lookBaseOld',
        name: 'SitemanageLookBaseOld',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '站点管理 · lookBaseOld', legacyPath: '/hp-cloud/html/sitemanage/lookBaseOld.html', complexity: 'C', migrated: true, quality: 'frame', module: 'sitemanage' }
      },
      {
        path: 'monitorboard',
        name: 'SitemanageMonitorboard',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '站点管理 · 监控看板', legacyPath: '/hp-cloud/html/sitemanage/monitorboard.html', complexity: 'C', migrated: true, quality: 'frame', module: 'sitemanage' }
      },
      {
        path: 'normal',
        name: 'SitemanageNormal',
        component: () => import('@/views/sitemanage/normal.vue'),
        meta: { title: '站点管理 · 常规看板', legacyPath: '/hp-cloud/html/sitemanage/normal.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'operationsAnalysis',
        name: 'SitemanageOperationsAnalysis',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '站点管理 · operationsAnalysis', legacyPath: '/hp-cloud/html/sitemanage/operationsAnalysis.html', complexity: 'B', migrated: true, quality: 'frame', module: 'sitemanage' }
      },
      {
        path: 'photovoltaicSys',
        name: 'SitemanagePhotovoltaicSys',
        component: () => import('@/views/sitemanage/photovoltaicSys.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/sitemanage/photovoltaicSys.html', complexity: 'C', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'pileList',
        name: 'SitemanagePileList',
        component: () => import('@/views/sitemanage/pileList.vue'),
        meta: { title: '站点管理 · 设备组番号', legacyPath: '/hp-cloud/html/sitemanage/pileList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'query',
        name: 'SitemanageQuery',
        component: () => import('@/views/sitemanage/query.vue'),
        meta: { title: '站点管理 · 列表查询', legacyPath: '/hp-cloud/html/sitemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'queryChargLog',
        name: 'SitemanageQueryChargLog',
        component: () => import('@/views/sitemanage/queryChargLog.vue'),
        meta: { title: '站点管理 · 充电桩分类', legacyPath: '/hp-cloud/html/sitemanage/queryChargLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'queryCodeHash',
        name: 'SitemanageQueryCodeHash',
        component: () => import('@/views/sitemanage/queryCodeHash.vue'),
        meta: { title: '站点管理 · 桩ID', legacyPath: '/hp-cloud/html/sitemanage/queryCodeHash.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'queryDateTimeLog',
        name: 'SitemanageQueryDateTimeLog',
        component: () => import('@/views/sitemanage/queryDateTimeLog.vue'),
        meta: { title: '站点管理 · 充电桩分类', legacyPath: '/hp-cloud/html/sitemanage/queryDateTimeLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'queryMacAddList',
        name: 'SitemanageQueryMacAddList',
        component: () => import('@/views/sitemanage/queryMacAddList.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/sitemanage/queryMacAddList.html', complexity: 'C', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'queryOnlineTime',
        name: 'SitemanageQueryOnlineTime',
        component: () => import('@/views/sitemanage/queryOnlineTime.vue'),
        meta: { title: '站点管理 · 桩ID', legacyPath: '/hp-cloud/html/sitemanage/queryOnlineTime.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'queryStatistics',
        name: 'SitemanageQueryStatistics',
        component: () => import('@/views/sitemanage/queryStatistics.vue'),
        meta: { title: '站点管理 · 桩ID', legacyPath: '/hp-cloud/html/sitemanage/queryStatistics.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'queryUserLog',
        name: 'SitemanageQueryUserLog',
        component: () => import('@/views/sitemanage/queryUserLog.vue'),
        meta: { title: '站点管理 · 用户名', legacyPath: '/hp-cloud/html/sitemanage/queryUserLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'siteCabinetDetail',
        name: 'SitemanageSiteCabinetDetail',
        component: () => import('@/views/sitemanage/siteCabinetDetail.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/sitemanage/siteCabinetDetail.html', complexity: 'C', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'siteCharging',
        name: 'SitemanageSiteCharging',
        component: () => import('@/views/sitemanage/siteCharging.vue'),
        meta: { title: '站点管理 · 日期', legacyPath: '/hp-cloud/html/sitemanage/siteCharging.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'siteChargingNew',
        name: 'SitemanageSiteChargingNew',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '站点管理 · siteChargingNew', legacyPath: '/hp-cloud/html/sitemanage/siteChargingNew.html', complexity: 'C', migrated: true, quality: 'frame', module: 'sitemanage' }
      },
      {
        path: 'siteChargingNum',
        name: 'SitemanageSiteChargingNum',
        component: () => import('@/views/sitemanage/siteChargingNum.vue'),
        meta: { title: '站点管理 · 日期', legacyPath: '/hp-cloud/html/sitemanage/siteChargingNum.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' }
      },
      {
        path: 'siteChargingNumNew',
        name: 'SitemanageSiteChargingNumNew',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '站点管理 · siteChargingNumNew', legacyPath: '/hp-cloud/html/sitemanage/siteChargingNumNew.html', complexity: 'B', migrated: true, quality: 'frame', module: 'sitemanage' }
      },
      {
        path: 'sitedetail',
        name: 'SitemanageSitedetail',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/sitemanage/sitedetail.html', complexity: 'C', migrated: true, quality: 'frame', module: 'sitemanage' }
      },
    ]
  },
  {
    path: '/ordermanage',
    name: 'OrdermanageModule',
    component: Layout,
    redirect: '/ordermanage/calRuleDetailtab',
    meta: { title: '订单管理', module: 'ordermanage' },
    children: [
      {
        path: 'calRuleDetailtab',
        name: 'OrdermanageCalRuleDetailtab',
        component: () => import('@/views/ordermanage/calRuleDetailtab.vue'),
        meta: { title: '订单管理 · 开始时间', legacyPath: '/hp-cloud/html/ordermanage/calRuleDetailtab.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' }
      },
      {
        path: 'orderAccount',
        name: 'OrdermanageOrderAccount',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '订单管理 · 类型', legacyPath: '/hp-cloud/html/ordermanage/orderAccount.html', complexity: 'A', migrated: true, quality: 'frame', module: 'ordermanage' }
      },
      {
        path: 'orderCharging',
        name: 'OrdermanageOrderCharging',
        component: () => import('@/views/ordermanage/orderCharging.vue'),
        meta: { title: '订单管理 · 日期', legacyPath: '/hp-cloud/html/ordermanage/orderCharging.html', complexity: 'B', migrated: true, quality: 'auto', module: 'ordermanage' }
      },
      {
        path: 'orderCount',
        name: 'OrdermanageOrderCount',
        component: () => import('@/views/ordermanage/orderCount.vue'),
        meta: { title: '订单管理 · 日期', legacyPath: '/hp-cloud/html/ordermanage/orderCount.html', complexity: 'B', migrated: true, quality: 'auto', module: 'ordermanage' }
      },
      {
        path: 'orderIncome',
        name: 'OrdermanageOrderIncome',
        component: () => import('@/views/ordermanage/orderIncome.vue'),
        meta: { title: '订单管理 · 日期', legacyPath: '/hp-cloud/html/ordermanage/orderIncome.html', complexity: 'B', migrated: true, quality: 'auto', module: 'ordermanage' }
      },
      {
        path: 'outorder/query',
        name: 'OrdermanageOutorderQuery',
        component: () => import('@/views/ordermanage/outorder/query.vue'),
        meta: { title: '订单管理 · outorder · 列表查询', legacyPath: '/hp-cloud/html/ordermanage/outorder/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' }
      },
      {
        path: 'parking/query',
        name: 'OrdermanageParkingQuery',
        component: () => import('@/views/ordermanage/parking/query.vue'),
        meta: { title: '订单管理 · parking · 列表查询', legacyPath: '/hp-cloud/html/ordermanage/parking/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' }
      },
      {
        path: 'query',
        name: 'OrdermanageQuery',
        component: () => import('@/views/ordermanage/query.vue'),
        meta: { title: '订单管理 · 列表查询', legacyPath: '/hp-cloud/html/ordermanage/query.html', complexity: 'B', migrated: true, quality: 'auto', module: 'ordermanage' }
      },
      {
        path: 'task/query',
        name: 'OrdermanageTaskQuery',
        component: () => import('@/views/ordermanage/task/query.vue'),
        meta: { title: '订单管理 · task · 列表查询', legacyPath: '/hp-cloud/html/ordermanage/task/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' }
      },
      {
        path: 'queryDetail',
        name: 'OrdermanageQueryDetail',
        component: () => import('@/views/ordermanage/queryDetail.vue'),
        meta: { title: '订单管理 · 明细查询', legacyPath: '/hp-cloud/html/ordermanage/queryDetail.html', complexity: 'C', migrated: true, quality: 'auto', module: 'ordermanage' }
      },
      {
        path: 'queryInvoice',
        name: 'OrdermanageQueryInvoice',
        component: () => import('@/views/ordermanage/queryInvoice.vue'),
        meta: { title: '订单管理 · queryInvoice', legacyPath: '/hp-cloud/html/ordermanage/queryInvoice.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' }
      },
      {
        path: 'queryOrderLog',
        name: 'OrdermanageQueryOrderLog',
        component: () => import('@/views/ordermanage/queryOrderLog.vue'),
        meta: { title: '订单履历', legacyPath: '/hp-cloud/html/ordermanage/queryOrderLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' }
      },
      {
        path: 'recharge',
        name: 'OrdermanageRecharge',
        component: () => import('@/views/ordermanage/recharge.vue'),
        meta: { title: '订单管理 · recharge', legacyPath: '/hp-cloud/html/ordermanage/recharge.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' }
      },
    ]
  },
  {
    path: '/dashboard',
    name: 'DashboardModule',
    component: Layout,
    redirect: '/dashboard/bigscreenNew',
    meta: { title: '数据看板', module: 'dashboard' },
    children: [
      {
        path: 'bigscreenNew',
        name: 'DashboardBigscreenNew',
        component: () => import('@/views/dashboard/bigscreenNew.vue'),
        meta: { title: '数据看板 · 可视化大屏', legacyPath: '/hp-cloud/html/dashboard/bigscreenNew.html', complexity: 'C', migrated: true, quality: 'done', module: 'dashboard' }
      },
      {
        path: 'groupDetailMap',
        name: 'DashboardGroupDetailMap',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '数据看板 · 站点分布明细', legacyPath: '/hp-cloud/html/dashboard/groupDetailMap.html', complexity: 'C', migrated: true, quality: 'frame', module: 'dashboard' }
      },
      {
        path: 'groupMap',
        name: 'DashboardGroupMap',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '数据看板 · 站点分布图', legacyPath: '/hp-cloud/html/dashboard/groupMap.html', complexity: 'C', migrated: true, quality: 'frame', module: 'dashboard' }
      },
      {
        path: 'normal',
        name: 'DashboardNormal',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '数据看板 · 常规看板', legacyPath: '/hp-cloud/html/dashboard/normal.html', complexity: 'C', migrated: true, quality: 'frame', module: 'dashboard' }
      },
      {
        path: 'offlineCountMonitor',
        name: 'DashboardOfflineCountMonitor',
        component: () => import('@/views/dashboard/offlineCountMonitor.vue'),
        meta: { title: '数据看板 · 离线统计监控', legacyPath: '/hp-cloud/html/dashboard/offlineCountMonitor.html', complexity: 'A', migrated: true, quality: 'auto', module: 'dashboard' }
      },
      {
        path: 'offlineMonitor',
        name: 'DashboardOfflineMonitor',
        component: () => import('@/views/dashboard/offlineMonitor.vue'),
        meta: { title: '数据看板 · 离线监控', legacyPath: '/hp-cloud/html/dashboard/offlineMonitor.html', complexity: 'A', migrated: true, quality: 'auto', module: 'dashboard' }
      },
      {
        path: 'siteMonitorMapCluster',
        name: 'DashboardSiteMonitorMapCluster',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '数据看板 · 站点聚合地图', legacyPath: '/hp-cloud/html/dashboard/siteMonitorMapCluster.html', complexity: 'C', migrated: true, quality: 'frame', module: 'dashboard' }
      },
    ]
  },
  {
    path: '/pilesync',
    name: 'PilesyncModule',
    component: Layout,
    redirect: '/pilesync/calRuleDetail',
    meta: { title: '充电桩同步', module: 'pilesync' },
    children: [
      {
        path: 'calRuleDetail',
        name: 'PilesyncCalRuleDetail',
        component: () => import('@/views/pilesync/calRuleDetail.vue'),
        meta: { title: '充电桩同步 · 类别', legacyPath: '/hp-cloud/html/pilesync/calRuleDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' }
      },
      {
        path: 'offlineQueryLog',
        name: 'PilesyncOfflineQueryLog',
        component: () => import('@/views/pilesync/offlineQueryLog.vue'),
        meta: { title: '充电桩同步 · 桩ID', legacyPath: '/hp-cloud/html/pilesync/offlineQueryLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' }
      },
      {
        path: 'pileOptLog',
        name: 'PilesyncPileOptLog',
        component: () => import('@/views/pilesync/pileOptLog.vue'),
        meta: { title: '充电桩同步 · 桩ID', legacyPath: '/hp-cloud/html/pilesync/pileOptLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' }
      },
      {
        path: 'queryCalRule',
        name: 'PilesyncQueryCalRule',
        component: () => import('@/views/pilesync/queryCalRule.vue'),
        meta: { title: '充电桩同步 · 选择', legacyPath: '/hp-cloud/html/pilesync/queryCalRule.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' }
      },
      {
        path: 'queryCalRuleList',
        name: 'PilesyncQueryCalRuleList',
        component: () => import('@/views/pilesync/queryCalRuleList.vue'),
        meta: { title: '充电桩同步 · 桩编号', legacyPath: '/hp-cloud/html/pilesync/queryCalRuleList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'pilesync' }
      },
      {
        path: 'queryDtuList',
        name: 'PilesyncQueryDtuList',
        component: () => import('@/views/pilesync/queryDtuList.vue'),
        meta: { title: '充电桩同步 · 桩编号', legacyPath: '/hp-cloud/html/pilesync/queryDtuList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'pilesync' }
      },
      {
        path: 'queryIpList',
        name: 'PilesyncQueryIpList',
        component: () => import('@/views/pilesync/queryIpList.vue'),
        meta: { title: '充电桩同步 · 桩编号', legacyPath: '/hp-cloud/html/pilesync/queryIpList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'pilesync' }
      },
      {
        path: 'queryOfflineList',
        name: 'PilesyncQueryOfflineList',
        component: () => import('@/views/pilesync/queryOfflineList.vue'),
        meta: { title: '充电桩同步 · 桩编号', legacyPath: '/hp-cloud/html/pilesync/queryOfflineList.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' }
      },
      {
        path: 'queryProgram',
        name: 'PilesyncQueryProgram',
        component: () => import('@/views/pilesync/queryProgram.vue'),
        meta: { title: '充电桩同步 · 选择', legacyPath: '/hp-cloud/html/pilesync/queryProgram.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' }
      },
      {
        path: 'queryProgramList',
        name: 'PilesyncQueryProgramList',
        component: () => import('@/views/pilesync/queryProgramList.vue'),
        meta: { title: '充电桩同步 · 桩ID', legacyPath: '/hp-cloud/html/pilesync/queryProgramList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'pilesync' }
      },
      {
        path: 'queryProgramSycnLog',
        name: 'PilesyncQueryProgramSycnLog',
        component: () => import('@/views/pilesync/queryProgramSycnLog.vue'),
        meta: { title: '充电桩同步 · 桩编号', legacyPath: '/hp-cloud/html/pilesync/queryProgramSycnLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' }
      },
      {
        path: 'queryTrader',
        name: 'PilesyncQueryTrader',
        component: () => import('@/views/pilesync/queryTrader.vue'),
        meta: { title: '充电桩同步 · 选择', legacyPath: '/hp-cloud/html/pilesync/queryTrader.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' }
      },
      {
        path: 'queryTraderList',
        name: 'PilesyncQueryTraderList',
        component: () => import('@/views/pilesync/queryTraderList.vue'),
        meta: { title: '充电桩同步 · 桩编号', legacyPath: '/hp-cloud/html/pilesync/queryTraderList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'pilesync' }
      },
      {
        path: 'settingSysIp',
        name: 'PilesyncSettingSysIp',
        component: () => import('@/views/pilesync/settingSysIp.vue'),
        meta: { title: '充电桩同步 · settingSysIp', legacyPath: '/hp-cloud/html/pilesync/settingSysIp.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' }
      },
    ]
  },
  {
    path: '/monitorboard',
    name: 'MonitorboardModule',
    component: Layout,
    redirect: '/monitorboard/edit',
    meta: { title: '监控看板', module: 'monitorboard' },
    children: [
      {
        path: 'edit',
        name: 'MonitorboardEdit',
        component: () => import('@/views/monitorboard/edit.vue'),
        meta: { title: '监控看板 · 新增/编辑', legacyPath: '/hp-cloud/html/monitorboard/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'monitorboard' }
      },
      {
        path: 'editType',
        name: 'MonitorboardEditType',
        component: () => import('@/views/monitorboard/editType.vue'),
        meta: { title: '监控看板 · editType', legacyPath: '/hp-cloud/html/monitorboard/editType.html', complexity: 'A', migrated: true, quality: 'auto', module: 'monitorboard' }
      },
      {
        path: 'playback',
        name: 'MonitorboardPlayback',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '视频监控回放 - 华鹏充电桩运营管理平台', legacyPath: '/hp-cloud/html/monitorboard/playback.html', complexity: 'C', migrated: true, quality: 'frame', module: 'monitorboard' }
      },
      {
        path: 'query',
        name: 'MonitorboardQuery',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '监控看板 · 列表查询', legacyPath: '/hp-cloud/html/monitorboard/query.html', complexity: 'C', migrated: true, quality: 'frame', module: 'monitorboard' }
      },
      {
        path: 'queryList',
        name: 'MonitorboardQueryList',
        component: () => import('@/views/monitorboard/queryList.vue'),
        meta: { title: '监控看板 · queryList', legacyPath: '/hp-cloud/html/monitorboard/queryList.html', complexity: 'A', migrated: true, quality: 'auto', module: 'monitorboard' }
      },
      {
        path: 'queryType',
        name: 'MonitorboardQueryType',
        component: () => import('@/views/monitorboard/queryType.vue'),
        meta: { title: '监控看板 · queryType', legacyPath: '/hp-cloud/html/monitorboard/queryType.html', complexity: 'A', migrated: true, quality: 'auto', module: 'monitorboard' }
      },
    ]
  },
  {
    path: '/storageenergy',
    name: 'StorageenergyModule',
    component: Layout,
    redirect: '/storageenergy/edit',
    meta: { title: '储能管理', module: 'storageenergy' },
    children: [
      {
        path: 'edit',
        name: 'StorageenergyEdit',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '储能管理 · 新增/编辑', legacyPath: '/hp-cloud/html/storageenergy/edit.html', complexity: 'C', migrated: true, quality: 'frame', module: 'storageenergy' }
      },
      {
        path: 'lookBase',
        name: 'StorageenergyLookBase',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '储能管理 · lookBase', legacyPath: '/hp-cloud/html/storageenergy/lookBase.html', complexity: 'C', migrated: true, quality: 'frame', module: 'storageenergy' }
      },
      {
        path: 'monitorboard',
        name: 'StorageenergyMonitorboard',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '储能管理 · 监控看板', legacyPath: '/hp-cloud/html/storageenergy/monitorboard.html', complexity: 'C', migrated: true, quality: 'frame', module: 'storageenergy' }
      },
      {
        path: 'query',
        name: 'StorageenergyQuery',
        component: () => import('@/views/storageenergy/query.vue'),
        meta: { title: '储能管理 · 列表查询', legacyPath: '/hp-cloud/html/storageenergy/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'storageenergy' }
      },
    ]
  },
  {
    path: '/calrule',
    name: 'CalruleModule',
    component: Layout,
    redirect: '/calrule/edit',
    meta: { title: '计费规则', module: 'calrule' },
    children: [
      {
        path: 'edit',
        name: 'CalruleEdit',
        component: () => import('@/views/calrule/edit.vue'),
        meta: { title: '计费规则 · 新增/编辑', legacyPath: '/hp-cloud/html/calrule/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'calrule' }
      },
      {
        path: 'pop',
        name: 'CalrulePop',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '计费规则 · pop', legacyPath: '/hp-cloud/html/calrule/pop.html', complexity: 'A', migrated: true, quality: 'frame', module: 'calrule' }
      },
      {
        path: 'query',
        name: 'CalruleQuery',
        component: () => import('@/views/calrule/query.vue'),
        meta: { title: '计费规则 · 列表查询', legacyPath: '/hp-cloud/html/calrule/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'calrule' }
      },
    ]
  },
  {
    path: '/usermanage',
    name: 'UsermanageModule',
    component: Layout,
    redirect: '/usermanage/accumulate',
    meta: { title: '用户管理', module: 'usermanage' },
    children: [
      {
        path: 'accumulate',
        name: 'UsermanageAccumulate',
        component: () => import('@/views/usermanage/accumulate.vue'),
        meta: { title: '用户管理 · 用户ID', legacyPath: '/hp-cloud/html/usermanage/accumulate.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' }
      },
      {
        path: 'addEmployee',
        name: 'UsermanageAddEmployee',
        component: () => import('@/views/usermanage/addEmployee.vue'),
        meta: { title: '用户管理 · 新增员工', legacyPath: '/hp-cloud/html/usermanage/addEmployee.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' }
      },
      {
        path: 'application',
        name: 'UsermanageApplication',
        component: () => import('@/views/usermanage/application.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/usermanage/application.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' }
      },
      {
        path: 'changePwd',
        name: 'UsermanageChangePwd',
        component: () => import('@/views/usermanage/changePwd.vue'),
        meta: { title: '用户管理 · changePwd', legacyPath: '/hp-cloud/html/usermanage/changePwd.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' }
      },
      {
        path: 'edit',
        name: 'UsermanageEdit',
        component: () => import('@/views/usermanage/edit.vue'),
        meta: { title: '用户管理 · 新增/编辑', legacyPath: '/hp-cloud/html/usermanage/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'usermanage' }
      },
      {
        path: 'employee',
        name: 'UsermanageEmployee',
        component: () => import('@/views/usermanage/employee.vue'),
        meta: { title: '用户管理 · 员工用户名', legacyPath: '/hp-cloud/html/usermanage/employee.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' }
      },
      {
        path: 'lockOpt',
        name: 'UsermanageLockOpt',
        component: () => import('@/views/usermanage/lockOpt.vue'),
        meta: { title: '用户管理 · lockOpt', legacyPath: '/hp-cloud/html/usermanage/lockOpt.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' }
      },
      {
        path: 'query',
        name: 'UsermanageQuery',
        component: () => import('@/views/usermanage/query.vue'),
        meta: { title: '用户管理 · 列表查询', legacyPath: '/hp-cloud/html/usermanage/query.html', complexity: 'B', migrated: true, quality: 'done', module: 'usermanage' }
      },
      {
        path: 'queryCompanyInfo',
        name: 'UsermanageQueryCompanyInfo',
        component: () => import('@/views/usermanage/queryCompanyInfo.vue'),
        meta: { title: '用户管理 · 企业信息', legacyPath: '/hp-cloud/html/usermanage/queryCompanyInfo.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' }
      },
      {
        path: 'queryOperatingRecord',
        name: 'UsermanageQueryOperatingRecord',
        component: () => import('@/views/usermanage/queryOperatingRecord.vue'),
        meta: { title: '用户管理 · 操作记录', legacyPath: '/hp-cloud/html/usermanage/queryOperatingRecord.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' }
      },
      {
        path: 'queryUserRole',
        name: 'UsermanageQueryUserRole',
        component: () => import('@/views/usermanage/queryUserRole.vue'),
        meta: { title: '用户管理 · 用户角色', legacyPath: '/hp-cloud/html/usermanage/queryUserRole.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' }
      },
      {
        path: 'recharge',
        name: 'UsermanageRecharge',
        component: () => import('@/views/usermanage/recharge.vue'),
        meta: { title: '用户管理 · recharge', legacyPath: '/hp-cloud/html/usermanage/recharge.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' }
      },
    ]
  },
  {
    path: '/traderuser',
    name: 'TraderuserModule',
    component: Layout,
    redirect: '/traderuser/adduserpop',
    meta: { title: '商户用户', module: 'traderuser' },
    children: [
      {
        path: 'adduserpop',
        name: 'TraderuserAdduserpop',
        component: () => import('@/views/traderuser/adduserpop.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/traderuser/adduserpop.html', complexity: 'A', migrated: true, quality: 'auto', module: 'traderuser' }
      },
      {
        path: 'chooseShareprofit',
        name: 'TraderuserChooseShareprofit',
        component: () => import('@/views/traderuser/chooseShareprofit.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/traderuser/chooseShareprofit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'traderuser' }
      },
      {
        path: 'edit',
        name: 'TraderuserEdit',
        component: () => import('@/views/traderuser/edit.vue'),
        meta: { title: '商户用户 · 新增/编辑', legacyPath: '/hp-cloud/html/traderuser/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'traderuser' }
      },
      {
        path: 'query',
        name: 'TraderuserQuery',
        component: () => import('@/views/traderuser/query.vue'),
        meta: { title: '商户用户 · 列表查询', legacyPath: '/hp-cloud/html/traderuser/query.html', complexity: 'B', migrated: true, quality: 'auto', module: 'traderuser' }
      },
      {
        path: 'userpop',
        name: 'TraderuserUserpop',
        component: () => import('@/views/traderuser/userpop.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/traderuser/userpop.html', complexity: 'A', migrated: true, quality: 'auto', module: 'traderuser' }
      },
    ]
  },
  {
    path: '/chargelists',
    name: 'ChargelistsModule',
    component: Layout,
    redirect: '/chargelists/chargedetail',
    meta: { title: '充电记录', module: 'chargelists' },
    children: [
      {
        path: 'chargedetail',
        name: 'ChargelistsChargedetail',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/chargelists/chargedetail.html', complexity: 'C', migrated: true, quality: 'frame', module: 'chargelists' }
      },
      {
        path: 'chargelists',
        name: 'ChargelistsChargelists',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/chargelists/chargelists.html', complexity: 'B', migrated: true, quality: 'frame', module: 'chargelists' }
      },
      {
        path: 'sitedetail',
        name: 'ChargelistsSitedetail',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/chargelists/sitedetail.html', complexity: 'C', migrated: true, quality: 'frame', module: 'chargelists' }
      },
    ]
  },
  {
    path: '/billtaskmanage',
    name: 'BilltaskmanageModule',
    component: Layout,
    redirect: '/billtaskmanage/addBillTask',
    meta: { title: '对账任务', module: 'billtaskmanage' },
    children: [
      {
        path: 'addBillTask',
        name: 'BilltaskmanageAddBillTask',
        component: () => import('@/views/billtaskmanage/addBillTask.vue'),
        meta: { title: '对账任务 · addBillTask', legacyPath: '/hp-cloud/html/billtaskmanage/addBillTask.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billtaskmanage' }
      },
      {
        path: 'assignUser',
        name: 'BilltaskmanageAssignUser',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '对账任务 · assignUser', legacyPath: '/hp-cloud/html/billtaskmanage/assignUser.html', complexity: 'A', migrated: true, quality: 'frame', module: 'billtaskmanage' }
      },
      {
        path: 'balanceBill',
        name: 'BilltaskmanageBalanceBill',
        component: () => import('@/views/billtaskmanage/balanceBill.vue'),
        meta: { title: '对账任务 · balanceBill', legacyPath: '/hp-cloud/html/billtaskmanage/balanceBill.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billtaskmanage' }
      },
      {
        path: 'confirm',
        name: 'BilltaskmanageConfirm',
        component: () => import('@/views/billtaskmanage/confirm.vue'),
        meta: { title: '对账任务 · confirm', legacyPath: '/hp-cloud/html/billtaskmanage/confirm.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billtaskmanage' }
      },
      {
        path: 'query',
        name: 'BilltaskmanageQuery',
        component: () => import('@/views/billtaskmanage/query.vue'),
        meta: { title: '对账任务 · 列表查询', legacyPath: '/hp-cloud/html/billtaskmanage/query.html', complexity: 'B', migrated: true, quality: 'auto', module: 'billtaskmanage' }
      },
      {
        path: 'queryDetail',
        name: 'BilltaskmanageQueryDetail',
        component: () => import('@/views/billtaskmanage/queryDetail.vue'),
        meta: { title: '对账任务 · 明细查询', legacyPath: '/hp-cloud/html/billtaskmanage/queryDetail.html', complexity: 'B', migrated: true, quality: 'auto', module: 'billtaskmanage' }
      },
      {
        path: 'queryMonthBill',
        name: 'BilltaskmanageQueryMonthBill',
        component: () => import('@/views/billtaskmanage/queryMonthBill.vue'),
        meta: { title: '对账任务 · 日期', legacyPath: '/hp-cloud/html/billtaskmanage/queryMonthBill.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billtaskmanage' }
      },
      {
        path: 'queryOrderList',
        name: 'BilltaskmanageQueryOrderList',
        component: () => import('@/views/billtaskmanage/queryOrderList.vue'),
        meta: { title: '对账任务 · 用户', legacyPath: '/hp-cloud/html/billtaskmanage/queryOrderList.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billtaskmanage' }
      },
      {
        path: 'queryUserMonthBill',
        name: 'BilltaskmanageQueryUserMonthBill',
        component: () => import('@/views/billtaskmanage/queryUserMonthBill.vue'),
        meta: { title: '对账任务 · 日期', legacyPath: '/hp-cloud/html/billtaskmanage/queryUserMonthBill.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billtaskmanage' }
      },
      {
        path: 'selectBillMonth',
        name: 'BilltaskmanageSelectBillMonth',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '对账任务 · selectBillMonth', legacyPath: '/hp-cloud/html/billtaskmanage/selectBillMonth.html', complexity: 'A', migrated: true, quality: 'frame', module: 'billtaskmanage' }
      },
    ]
  },
  {
    path: '/iccard',
    name: 'IccardModule',
    component: Layout,
    redirect: '/iccard/application',
    meta: { title: 'IC卡管理', module: 'iccard' },
    children: [
      {
        path: 'application',
        name: 'IccardApplication',
        component: () => import('@/views/iccard/application.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/iccard/application.html', complexity: 'A', migrated: true, quality: 'auto', module: 'iccard' }
      },
      {
        path: 'edit',
        name: 'IccardEdit',
        component: () => import('@/views/iccard/edit.vue'),
        meta: { title: 'IC卡管理 · 新增/编辑', legacyPath: '/hp-cloud/html/iccard/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'iccard' }
      },
      {
        path: 'pileBind',
        name: 'IccardPileBind',
        component: () => import('@/views/iccard/pileBind.vue'),
        meta: { title: 'IC卡管理 · pileBind', legacyPath: '/hp-cloud/html/iccard/pileBind.html', complexity: 'B', migrated: true, quality: 'auto', module: 'iccard' }
      },
      {
        path: 'query',
        name: 'IccardQuery',
        component: () => import('@/views/iccard/query.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/iccard/query.html', complexity: 'C', migrated: true, quality: 'auto', module: 'iccard' }
      },
      {
        path: 'queryLog',
        name: 'IccardQueryLog',
        component: () => import('@/views/iccard/queryLog.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/iccard/queryLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'iccard' }
      },
      {
        path: 'userpop',
        name: 'IccardUserpop',
        component: () => import('@/views/iccard/userpop.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/iccard/userpop.html', complexity: 'A', migrated: true, quality: 'auto', module: 'iccard' }
      },
    ]
  },
  {
    path: '/factorysetting',
    name: 'FactorysettingModule',
    component: Layout,
    redirect: '/factorysetting/barCodeInit',
    meta: { title: '出厂设置', module: 'factorysetting' },
    children: [
      {
        path: 'barCodeInit',
        name: 'FactorysettingBarCodeInit',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '出厂设置 · barCodeInit', legacyPath: '/hp-cloud/html/factorysetting/barCodeInit.html', complexity: 'A', migrated: true, quality: 'frame', module: 'factorysetting' }
      },
      {
        path: 'boundGun',
        name: 'FactorysettingBoundGun',
        component: () => import('@/views/factorysetting/boundGun.vue'),
        meta: { title: '出厂设置 · 电桩ID', legacyPath: '/hp-cloud/html/factorysetting/boundGun.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' }
      },
      {
        path: 'boundLock',
        name: 'FactorysettingBoundLock',
        component: () => import('@/views/factorysetting/boundLock.vue'),
        meta: { title: '出厂设置 · 网关名称', legacyPath: '/hp-cloud/html/factorysetting/boundLock.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' }
      },
      {
        path: 'editGun',
        name: 'FactorysettingEditGun',
        component: () => import('@/views/factorysetting/editGun.vue'),
        meta: { title: '出厂设置 · editGun', legacyPath: '/hp-cloud/html/factorysetting/editGun.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' }
      },
      {
        path: 'editPile',
        name: 'FactorysettingEditPile',
        component: () => import('@/views/factorysetting/editPile.vue'),
        meta: { title: '出厂设置 · editPile', legacyPath: '/hp-cloud/html/factorysetting/editPile.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' }
      },
      {
        path: 'import',
        name: 'FactorysettingImport',
        component: () => import('@/views/factorysetting/import.vue'),
        meta: { title: '出厂设置 · import', legacyPath: '/hp-cloud/html/factorysetting/import.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' }
      },
      {
        path: 'lock',
        name: 'FactorysettingLock',
        component: () => import('@/views/factorysetting/lock.vue'),
        meta: { title: '出厂设置 · lock', legacyPath: '/hp-cloud/html/factorysetting/lock.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' }
      },
      {
        path: 'pileInitialize',
        name: 'FactorysettingPileInitialize',
        component: () => import('@/views/factorysetting/pileInitialize.vue'),
        meta: { title: '出厂设置 · 桩ID', legacyPath: '/hp-cloud/html/factorysetting/pileInitialize.html', complexity: 'B', migrated: true, quality: 'auto', module: 'factorysetting' }
      },
      {
        path: 'query',
        name: 'FactorysettingQuery',
        component: () => import('@/views/factorysetting/query.vue'),
        meta: { title: '出厂设置 · 列表查询', legacyPath: '/hp-cloud/html/factorysetting/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' }
      },
    ]
  },
  {
    path: '/faultmanage',
    name: 'FaultmanageModule',
    component: Layout,
    redirect: '/faultmanage/faultDetail',
    meta: { title: '故障管理', module: 'faultmanage' },
    children: [
      {
        path: 'faultDetail',
        name: 'FaultmanageFaultDetail',
        component: () => import('@/views/faultmanage/faultDetail.vue'),
        meta: { title: '故障管理 · faultDetail', legacyPath: '/hp-cloud/html/faultmanage/faultDetail.html', complexity: 'B', migrated: true, quality: 'auto', module: 'faultmanage' }
      },
      {
        path: 'levelQuery',
        name: 'FaultmanageLevelQuery',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '故障管理 · levelQuery', legacyPath: '/hp-cloud/html/faultmanage/levelQuery.html', complexity: 'A', migrated: true, quality: 'frame', module: 'faultmanage' }
      },
      {
        path: 'queryDetail',
        name: 'FaultmanageQueryDetail',
        component: () => import('@/views/faultmanage/queryDetail.vue'),
        meta: { title: '故障管理 · 明细查询', legacyPath: '/hp-cloud/html/faultmanage/queryDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultmanage' }
      },
      {
        path: 'queryLog',
        name: 'FaultmanageQueryLog',
        component: () => import('@/views/faultmanage/queryLog.vue'),
        meta: { title: '故障履历', legacyPath: '/hp-cloud/html/faultmanage/queryLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultmanage' }
      },
      {
        path: 'startWorkOrder',
        name: 'FaultmanageStartWorkOrder',
        component: () => import('@/views/faultmanage/startWorkOrder.vue'),
        meta: { title: '故障管理 · startWorkOrder', legacyPath: '/hp-cloud/html/faultmanage/startWorkOrder.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultmanage' }
      },
      {
        path: 'statusQuery',
        name: 'FaultmanageStatusQuery',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '故障管理 · statusQuery', legacyPath: '/hp-cloud/html/faultmanage/statusQuery.html', complexity: 'B', migrated: true, quality: 'frame', module: 'faultmanage' }
      },
    ]
  },
  {
    path: '/mastercode',
    name: 'MastercodeModule',
    component: Layout,
    redirect: '/mastercode/editError',
    meta: { title: '主数据字典', module: 'mastercode' },
    children: [
      {
        path: 'editError',
        name: 'MastercodeEditError',
        component: () => import('@/views/mastercode/editError.vue'),
        meta: { title: '主数据字典 · editError', legacyPath: '/hp-cloud/html/mastercode/editError.html', complexity: 'A', migrated: true, quality: 'auto', module: 'mastercode' }
      },
      {
        path: 'operationsAnalysis',
        name: 'MastercodeOperationsAnalysis',
        component: () => import('@/views/mastercode/operationsAnalysis.vue'),
        meta: { title: '主数据字典 · 用户', legacyPath: '/hp-cloud/html/mastercode/operationsAnalysis.html', complexity: 'B', migrated: true, quality: 'auto', module: 'mastercode' }
      },
      {
        path: 'query',
        name: 'MastercodeQuery',
        component: () => import('@/views/mastercode/query.vue'),
        meta: { title: '主数据字典 · 列表查询', legacyPath: '/hp-cloud/html/mastercode/query.html', complexity: 'B', migrated: true, quality: 'auto', module: 'mastercode' }
      },
      {
        path: 'queryError',
        name: 'MastercodeQueryError',
        component: () => import('@/views/mastercode/queryError.vue'),
        meta: { title: '主数据字典 · 异常原因名称', legacyPath: '/hp-cloud/html/mastercode/queryError.html', complexity: 'A', migrated: true, quality: 'auto', module: 'mastercode' }
      },
    ]
  },
  {
    path: '/tools',
    name: 'ToolsModule',
    component: Layout,
    redirect: '/tools/addstandaloneprogram',
    meta: { title: '工具箱', module: 'tools' },
    children: [
      {
        path: 'addstandaloneprogram',
        name: 'ToolsAddstandaloneprogram',
        component: () => import('@/views/tools/addstandaloneprogram.vue'),
        meta: { title: '工具箱 · addstandaloneprogram', legacyPath: '/hp-cloud/html/tools/addstandaloneprogram.html', complexity: 'A', migrated: true, quality: 'auto', module: 'tools' }
      },
      {
        path: 'addwhiteblack',
        name: 'ToolsAddwhiteblack',
        component: () => import('@/views/tools/addwhiteblack.vue'),
        meta: { title: '工具箱 · addwhiteblack', legacyPath: '/hp-cloud/html/tools/addwhiteblack.html', complexity: 'A', migrated: true, quality: 'auto', module: 'tools' }
      },
      {
        path: 'chargelimitresetquery',
        name: 'ToolsChargelimitresetquery',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '工具箱 · 订单号', legacyPath: '/hp-cloud/html/tools/chargelimitresetquery.html', complexity: 'A', migrated: true, quality: 'frame', module: 'tools' }
      },
      {
        path: 'standalonedetail',
        name: 'ToolsStandalonedetail',
        component: () => import('@/views/tools/standalonedetail.vue'),
        meta: { title: '工具箱 · standalonedetail', legacyPath: '/hp-cloud/html/tools/standalonedetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'tools' }
      },
      {
        path: 'standalonequery',
        name: 'ToolsStandalonequery',
        component: () => import('@/views/tools/standalonequery.vue'),
        meta: { title: '工具箱 · 组织名称', legacyPath: '/hp-cloud/html/tools/standalonequery.html', complexity: 'A', migrated: true, quality: 'auto', module: 'tools' }
      },
      {
        path: 'whiteblackquery',
        name: 'ToolsWhiteblackquery',
        component: () => import('@/views/tools/whiteblackquery.vue'),
        meta: { title: '工具箱 · 用户名/IC卡号', legacyPath: '/hp-cloud/html/tools/whiteblackquery.html', complexity: 'A', migrated: true, quality: 'auto', module: 'tools' }
      },
    ]
  },
  {
    path: '/systemsetting',
    name: 'SystemsettingModule',
    component: Layout,
    redirect: '/systemsetting/edit',
    meta: { title: '系统设置', module: 'systemsetting' },
    children: [
      {
        path: 'edit',
        name: 'SystemsettingEdit',
        component: () => import('@/views/systemsetting/edit.vue'),
        meta: { title: '系统设置 · 新增/编辑', legacyPath: '/hp-cloud/html/systemsetting/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'systemsetting' }
      },
      {
        path: 'query',
        name: 'SystemsettingQuery',
        component: () => import('@/views/systemsetting/query.vue'),
        meta: { title: '系统设置 · 列表查询', legacyPath: '/hp-cloud/html/systemsetting/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'systemsetting' }
      },
      {
        path: 'shippingpop',
        name: 'SystemsettingShippingpop',
        component: () => import('@/views/systemsetting/shippingpop.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/systemsetting/shippingpop.html', complexity: 'A', migrated: true, quality: 'auto', module: 'systemsetting' }
      },
    ]
  },
  {
    path: '/transferstatistics',
    name: 'TransferstatisticsModule',
    component: Layout,
    redirect: '/transferstatistics/query',
    meta: { title: '转账统计', module: 'transferstatistics' },
    children: [
      {
        path: 'query',
        name: 'TransferstatisticsQuery',
        component: () => import('@/views/transferstatistics/query.vue'),
        meta: { title: '转账统计 · 列表查询', legacyPath: '/hp-cloud/html/transferstatistics/query.html', complexity: 'C', migrated: true, quality: 'auto', module: 'transferstatistics' }
      },
      {
        path: 'queryBillStatistics',
        name: 'TransferstatisticsQueryBillStatistics',
        component: () => import('@/views/transferstatistics/queryBillStatistics.vue'),
        meta: { title: '转账统计 · 转账日期', legacyPath: '/hp-cloud/html/transferstatistics/queryBillStatistics.html', complexity: 'C', migrated: true, quality: 'auto', module: 'transferstatistics' }
      },
    ]
  },
  {
    path: '/companymanage',
    name: 'CompanymanageModule',
    component: Layout,
    redirect: '/companymanage/application',
    meta: { title: '企业管理', module: 'companymanage' },
    children: [
      {
        path: 'application',
        name: 'CompanymanageApplication',
        component: () => import('@/views/companymanage/application.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/companymanage/application.html', complexity: 'B', migrated: true, quality: 'auto', module: 'companymanage' }
      },
      {
        path: 'assignGroup',
        name: 'CompanymanageAssignGroup',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '企业管理 · assignGroup', legacyPath: '/hp-cloud/html/companymanage/assignGroup.html', complexity: 'A', migrated: true, quality: 'frame', module: 'companymanage' }
      },
      {
        path: 'assignInterface',
        name: 'CompanymanageAssignInterface',
        component: () => import('@/views/companymanage/assignInterface.vue'),
        meta: { title: '企业管理 · 选择', legacyPath: '/hp-cloud/html/companymanage/assignInterface.html', complexity: 'A', migrated: true, quality: 'auto', module: 'companymanage' }
      },
      {
        path: 'queryCompanyInfo',
        name: 'CompanymanageQueryCompanyInfo',
        component: () => import('@/views/companymanage/queryCompanyInfo.vue'),
        meta: { title: '企业管理 · 企业信息', legacyPath: '/hp-cloud/html/companymanage/queryCompanyInfo.html', complexity: 'A', migrated: true, quality: 'auto', module: 'companymanage' }
      },
      {
        path: 'secretkey',
        name: 'CompanymanageSecretkey',
        component: () => import('@/views/companymanage/secretkey.vue'),
        meta: { title: '企业管理 · secretkey', legacyPath: '/hp-cloud/html/companymanage/secretkey.html', complexity: 'A', migrated: true, quality: 'auto', module: 'companymanage' }
      },
    ]
  },
  {
    path: '/shareprofitrule',
    name: 'ShareprofitruleModule',
    component: Layout,
    redirect: '/shareprofitrule/edit',
    meta: { title: '分成规则', module: 'shareprofitrule' },
    children: [
      {
        path: 'edit',
        name: 'ShareprofitruleEdit',
        component: () => import('@/views/shareprofitrule/edit.vue'),
        meta: { title: '分成规则 · 新增/编辑', legacyPath: '/hp-cloud/html/shareprofitrule/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'shareprofitrule' }
      },
      {
        path: 'editPop',
        name: 'ShareprofitruleEditPop',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '计算机类型规则管理', legacyPath: '/hp-cloud/html/shareprofitrule/editPop.html', complexity: 'A', migrated: true, quality: 'frame', module: 'shareprofitrule' }
      },
      {
        path: 'query',
        name: 'ShareprofitruleQuery',
        component: () => import('@/views/shareprofitrule/query.vue'),
        meta: { title: '分成规则 · 列表查询', legacyPath: '/hp-cloud/html/shareprofitrule/query.html', complexity: 'C', migrated: true, quality: 'auto', module: 'shareprofitrule' }
      },
    ]
  },
  {
    path: '/apiinfomanage',
    name: 'ApiinfomanageModule',
    component: Layout,
    redirect: '/apiinfomanage/apilog',
    meta: { title: '接口信息管理', module: 'apiinfomanage' },
    children: [
      {
        path: 'apilog',
        name: 'ApiinfomanageApilog',
        component: () => import('@/views/apiinfomanage/apilog.vue'),
        meta: { title: '接口信息管理 · 请求流水号', legacyPath: '/hp-cloud/html/apiinfomanage/apilog.html', complexity: 'B', migrated: true, quality: 'auto', module: 'apiinfomanage' }
      },
      {
        path: 'edit',
        name: 'ApiinfomanageEdit',
        component: () => import('@/views/apiinfomanage/edit.vue'),
        meta: { title: '接口信息管理 · 新增/编辑', legacyPath: '/hp-cloud/html/apiinfomanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'apiinfomanage' }
      },
      {
        path: 'loginfo',
        name: 'ApiinfomanageLoginfo',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '接口信息管理 · loginfo', legacyPath: '/hp-cloud/html/apiinfomanage/loginfo.html', complexity: 'A', migrated: true, quality: 'frame', module: 'apiinfomanage' }
      },
      {
        path: 'query',
        name: 'ApiinfomanageQuery',
        component: () => import('@/views/apiinfomanage/query.vue'),
        meta: { title: '接口信息管理 · 列表查询', legacyPath: '/hp-cloud/html/apiinfomanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'apiinfomanage' }
      },
    ]
  },
  {
    path: '/devicerepository',
    name: 'DevicerepositoryModule',
    component: Layout,
    redirect: '/devicerepository/detail',
    meta: { title: '设备库', module: 'devicerepository' },
    children: [
      {
        path: 'detail',
        name: 'DevicerepositoryDetail',
        component: () => import('@/views/devicerepository/detail.vue'),
        meta: { title: '设备库 · 详情', legacyPath: '/hp-cloud/html/devicerepository/detail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'devicerepository' }
      },
      {
        path: 'edit',
        name: 'DevicerepositoryEdit',
        component: () => import('@/views/devicerepository/edit.vue'),
        meta: { title: '设备库 · 新增/编辑', legacyPath: '/hp-cloud/html/devicerepository/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'devicerepository' }
      },
      {
        path: 'query',
        name: 'DevicerepositoryQuery',
        component: () => import('@/views/devicerepository/query.vue'),
        meta: { title: '设备库 · 列表查询', legacyPath: '/hp-cloud/html/devicerepository/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'devicerepository' }
      },
    ]
  },
  {
    path: '/analysisdashboard',
    name: 'AnalysisdashboardModule',
    component: Layout,
    redirect: '/analysisdashboard/query',
    meta: { title: '分析看板', module: 'analysisdashboard' },
    children: [
      {
        path: 'query',
        name: 'AnalysisdashboardQuery',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '分析看板 · 列表查询', legacyPath: '/hp-cloud/html/analysisdashboard/query.html', complexity: 'B', migrated: true, quality: 'frame', module: 'analysisdashboard' }
      },
    ]
  },
  {
    path: '/unicomdevice',
    name: 'UnicomdeviceModule',
    component: Layout,
    redirect: '/unicomdevice/query',
    meta: { title: '联通设备', module: 'unicomdevice' },
    children: [
      {
        path: 'query',
        name: 'UnicomdeviceQuery',
        component: () => import('@/views/unicomdevice/query.vue'),
        meta: { title: '联通设备 · 列表查询', legacyPath: '/hp-cloud/html/unicomdevice/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'unicomdevice' }
      },
      {
        path: 'queryDetail',
        name: 'UnicomdeviceQueryDetail',
        component: () => import('@/views/unicomdevice/queryDetail.vue'),
        meta: { title: '联通设备 · 明细查询', legacyPath: '/hp-cloud/html/unicomdevice/queryDetail.html', complexity: 'C', migrated: true, quality: 'auto', module: 'unicomdevice' }
      },
    ]
  },
  {
    path: '/messagemanage',
    name: 'MessagemanageModule',
    component: Layout,
    redirect: '/messagemanage/edit',
    meta: { title: '消息管理', module: 'messagemanage' },
    children: [
      {
        path: 'edit',
        name: 'MessagemanageEdit',
        component: () => import('@/views/messagemanage/edit.vue'),
        meta: { title: '消息管理 · 新增/编辑', legacyPath: '/hp-cloud/html/messagemanage/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'messagemanage' }
      },
      {
        path: 'historyQuery',
        name: 'MessagemanageHistoryQuery',
        component: () => import('@/views/messagemanage/historyQuery.vue'),
        meta: { title: '消息管理 · 消息类型', legacyPath: '/hp-cloud/html/messagemanage/historyQuery.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagemanage' }
      },
      {
        path: 'preview',
        name: 'MessagemanagePreview',
        component: () => import('@/views/messagemanage/preview.vue'),
        meta: { title: '消息管理 · preview', legacyPath: '/hp-cloud/html/messagemanage/preview.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagemanage' }
      },
      {
        path: 'query',
        name: 'MessagemanageQuery',
        component: () => import('@/views/messagemanage/query.vue'),
        meta: { title: '消息管理 · 列表查询', legacyPath: '/hp-cloud/html/messagemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagemanage' }
      },
      {
        path: 'sendMessage',
        name: 'MessagemanageSendMessage',
        component: () => import('@/views/messagemanage/sendMessage.vue'),
        meta: { title: '消息管理 · sendMessage', legacyPath: '/hp-cloud/html/messagemanage/sendMessage.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagemanage' }
      },
      {
        path: 'sendUserLog',
        name: 'MessagemanageSendUserLog',
        component: () => import('@/views/messagemanage/sendUserLog.vue'),
        meta: { title: '消息管理 · 用户名', legacyPath: '/hp-cloud/html/messagemanage/sendUserLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagemanage' }
      },
    ]
  },
  {
    path: '/invoicerequestmanage',
    name: 'InvoicerequestmanageModule',
    component: Layout,
    redirect: '/invoicerequestmanage/invoicePreview',
    meta: { title: '开票申请', module: 'invoicerequestmanage' },
    children: [
      {
        path: 'invoicePreview',
        name: 'InvoicerequestmanageInvoicePreview',
        component: () => import('@/views/invoicerequestmanage/invoicePreview.vue'),
        meta: { title: '发票详情', legacyPath: '/hp-cloud/html/invoicerequestmanage/invoicePreview.html', complexity: 'B', migrated: true, quality: 'auto', module: 'invoicerequestmanage' }
      },
      {
        path: 'invoiceUpload',
        name: 'InvoicerequestmanageInvoiceUpload',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '开票申请 · invoiceUpload', legacyPath: '/hp-cloud/html/invoicerequestmanage/invoiceUpload.html', complexity: 'A', migrated: true, quality: 'frame', module: 'invoicerequestmanage' }
      },
      {
        path: 'query',
        name: 'InvoicerequestmanageQuery',
        component: () => import('@/views/invoicerequestmanage/query.vue'),
        meta: { title: '开票申请 · 列表查询', legacyPath: '/hp-cloud/html/invoicerequestmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'invoicerequestmanage' }
      },
      {
        path: 'queryInvoice',
        name: 'InvoicerequestmanageQueryInvoice',
        component: () => import('@/views/invoicerequestmanage/queryInvoice.vue'),
        meta: { title: '发票详情', legacyPath: '/hp-cloud/html/invoicerequestmanage/queryInvoice.html', complexity: 'B', migrated: true, quality: 'auto', module: 'invoicerequestmanage' }
      },
    ]
  },
  {
    path: '/logsetting',
    name: 'LogsettingModule',
    component: Layout,
    redirect: '/logsetting/logDetail',
    meta: { title: '日志设置', module: 'logsetting' },
    children: [
      {
        path: 'logDetail',
        name: 'LogsettingLogDetail',
        component: () => import('@/views/logsetting/logDetail.vue'),
        meta: { title: '日志设置 · 字段名', legacyPath: '/hp-cloud/html/logsetting/logDetail.html', complexity: 'B', migrated: true, quality: 'auto', module: 'logsetting' }
      },
      {
        path: 'query',
        name: 'LogsettingQuery',
        component: () => import('@/views/logsetting/query.vue'),
        meta: { title: '日志设置 · 列表查询', legacyPath: '/hp-cloud/html/logsetting/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'logsetting' }
      },
    ]
  },
  {
    path: '/articlemanage',
    name: 'ArticlemanageModule',
    component: Layout,
    redirect: '/articlemanage/edit',
    meta: { title: '文章管理', module: 'articlemanage' },
    children: [
      {
        path: 'edit',
        name: 'ArticlemanageEdit',
        component: () => import('@/views/articlemanage/edit.vue'),
        meta: { title: '文章管理 · 新增/编辑', legacyPath: '/hp-cloud/html/articlemanage/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'articlemanage' }
      },
      {
        path: 'preview',
        name: 'ArticlemanagePreview',
        component: () => import('@/views/articlemanage/preview.vue'),
        meta: { title: '文章管理 · preview', legacyPath: '/hp-cloud/html/articlemanage/preview.html', complexity: 'A', migrated: true, quality: 'auto', module: 'articlemanage' }
      },
      {
        path: 'query',
        name: 'ArticlemanageQuery',
        component: () => import('@/views/articlemanage/query.vue'),
        meta: { title: '文章管理 · 列表查询', legacyPath: '/hp-cloud/html/articlemanage/query.html', complexity: 'B', migrated: true, quality: 'auto', module: 'articlemanage' }
      },
    ]
  },
  {
    path: '/couponmanage',
    name: 'CouponmanageModule',
    component: Layout,
    redirect: '/couponmanage/query',
    meta: { title: '优惠券管理', module: 'couponmanage' },
    children: [
      {
        path: 'query',
        name: 'CouponmanageQuery',
        component: () => import('@/views/couponmanage/query.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/couponmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'couponmanage' }
      },
      {
        path: 'queryCoupon',
        name: 'CouponmanageQueryCoupon',
        component: () => import('@/views/couponmanage/queryCoupon.vue'),
        meta: { title: '优惠券管理 · queryCoupon', legacyPath: '/hp-cloud/html/couponmanage/queryCoupon.html', complexity: 'A', migrated: true, quality: 'auto', module: 'couponmanage' }
      },
      {
        path: 'receivingRecords',
        name: 'CouponmanageReceivingRecords',
        component: () => import('@/views/couponmanage/receivingRecords.vue'),
        meta: { title: '优惠券管理 · 持有者用户名', legacyPath: '/hp-cloud/html/couponmanage/receivingRecords.html', complexity: 'A', migrated: true, quality: 'auto', module: 'couponmanage' }
      },
      {
        path: 'sendCoupon',
        name: 'CouponmanageSendCoupon',
        component: () => import('@/views/couponmanage/sendCoupon.vue'),
        meta: { title: '优惠券管理 · sendCoupon', legacyPath: '/hp-cloud/html/couponmanage/sendCoupon.html', complexity: 'A', migrated: true, quality: 'auto', module: 'couponmanage' }
      },
    ]
  },
  {
    path: '/rolemanage',
    name: 'RolemanageModule',
    component: Layout,
    redirect: '/rolemanage/edit',
    meta: { title: '角色管理', module: 'rolemanage' },
    children: [
      {
        path: 'edit',
        name: 'RolemanageEdit',
        component: () => import('@/views/rolemanage/edit.vue'),
        meta: { title: '角色管理 · 新增/编辑', legacyPath: '/hp-cloud/html/rolemanage/edit.html', complexity: 'A', migrated: true, quality: 'done', module: 'rolemanage' }
      },
      {
        path: 'query',
        name: 'RolemanageQuery',
        component: () => import('@/views/rolemanage/query.vue'),
        meta: { title: '角色管理 · 列表查询', legacyPath: '/hp-cloud/html/rolemanage/query.html', complexity: 'A', migrated: true, quality: 'done', module: 'rolemanage' }
      },
      {
        path: 'queryResource',
        name: 'RolemanageQueryResource',
        component: () => import('@/views/rolemanage/queryResource.vue'),
        meta: { title: '角色管理 · 资源授权', legacyPath: '/hp-cloud/html/rolemanage/queryResource.html', complexity: 'A', migrated: true, quality: 'done', module: 'rolemanage' }
      },
      {
        path: 'queryUserRole',
        name: 'RolemanageQueryUserRole',
        component: () => import('@/views/rolemanage/queryUserRole.vue'),
        meta: { title: '角色管理 · 用户角色', legacyPath: '/hp-cloud/html/rolemanage/queryUserRole.html', complexity: 'A', migrated: true, quality: 'done', module: 'rolemanage' }
      },
    ]
  },
  {
    path: '/advermanage',
    name: 'AdvermanageModule',
    component: Layout,
    redirect: '/advermanage/edit',
    meta: { title: '广告管理', module: 'advermanage' },
    children: [
      {
        path: 'edit',
        name: 'AdvermanageEdit',
        component: () => import('@/views/advermanage/edit.vue'),
        meta: { title: '广告管理 · 新增/编辑', legacyPath: '/hp-cloud/html/advermanage/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'advermanage' }
      },
      {
        path: 'preview',
        name: 'AdvermanagePreview',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '广告管理 · preview', legacyPath: '/hp-cloud/html/advermanage/preview.html', complexity: 'A', migrated: true, quality: 'frame', module: 'advermanage' }
      },
      {
        path: 'query',
        name: 'AdvermanageQuery',
        component: () => import('@/views/advermanage/query.vue'),
        meta: { title: '广告管理 · 列表查询', legacyPath: '/hp-cloud/html/advermanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'advermanage' }
      },
    ]
  },
  {
    path: '/programmanage',
    name: 'ProgrammanageModule',
    component: Layout,
    redirect: '/programmanage/edit',
    meta: { title: '程序管理', module: 'programmanage' },
    children: [
      {
        path: 'edit',
        name: 'ProgrammanageEdit',
        component: () => import('@/views/programmanage/edit.vue'),
        meta: { title: '程序管理 · 新增/编辑', legacyPath: '/hp-cloud/html/programmanage/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'programmanage' }
      },
      {
        path: 'query',
        name: 'ProgrammanageQuery',
        component: () => import('@/views/programmanage/query.vue'),
        meta: { title: '程序管理 · 列表查询', legacyPath: '/hp-cloud/html/programmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'programmanage' }
      },
    ]
  },
  {
    path: '/integratedpanel',
    name: 'IntegratedpanelModule',
    component: Layout,
    redirect: '/integratedpanel/show',
    meta: { title: '综合面板', module: 'integratedpanel' },
    children: [
      {
        path: 'show',
        name: 'IntegratedpanelShow',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '综合面板', legacyPath: '/hp-cloud/html/integratedpanel/show.html', complexity: 'B', migrated: true, quality: 'frame', module: 'integratedpanel' }
      },
    ]
  },
  {
    path: '/faultrulemanage',
    name: 'FaultrulemanageModule',
    component: Layout,
    redirect: '/faultrulemanage/edit',
    meta: { title: '故障规则', module: 'faultrulemanage' },
    children: [
      {
        path: 'edit',
        name: 'FaultrulemanageEdit',
        component: () => import('@/views/faultrulemanage/edit.vue'),
        meta: { title: '故障规则 · 新增/编辑', legacyPath: '/hp-cloud/html/faultrulemanage/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'faultrulemanage' }
      },
      {
        path: 'query',
        name: 'FaultrulemanageQuery',
        component: () => import('@/views/faultrulemanage/query.vue'),
        meta: { title: '故障规则 · 列表查询', legacyPath: '/hp-cloud/html/faultrulemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultrulemanage' }
      },
    ]
  },
  {
    path: '/thirdpartyuser',
    name: 'ThirdpartyuserModule',
    component: Layout,
    redirect: '/thirdpartyuser/edit',
    meta: { title: '第三方用户', module: 'thirdpartyuser' },
    children: [
      {
        path: 'edit',
        name: 'ThirdpartyuserEdit',
        component: () => import('@/views/thirdpartyuser/edit.vue'),
        meta: { title: '第三方用户 · 新增/编辑', legacyPath: '/hp-cloud/html/thirdpartyuser/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'thirdpartyuser' }
      },
      {
        path: 'query',
        name: 'ThirdpartyuserQuery',
        component: () => import('@/views/thirdpartyuser/query.vue'),
        meta: { title: '第三方用户 · 列表查询', legacyPath: '/hp-cloud/html/thirdpartyuser/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'thirdpartyuser' }
      },
    ]
  },
  {
    path: '/billmanage',
    name: 'BillmanageModule',
    component: Layout,
    redirect: '/billmanage/edit',
    meta: { title: '账单管理', module: 'billmanage' },
    children: [
      {
        path: 'edit',
        name: 'BillmanageEdit',
        component: () => import('@/views/billmanage/edit.vue'),
        meta: { title: '账单管理 · 新增/编辑', legacyPath: '/hp-cloud/html/billmanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billmanage' }
      },
      {
        path: 'query',
        name: 'BillmanageQuery',
        component: () => import('@/views/billmanage/query.vue'),
        meta: { title: '账单管理 · 列表查询', legacyPath: '/hp-cloud/html/billmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billmanage' }
      },
      {
        path: 'updatePrice',
        name: 'BillmanageUpdatePrice',
        component: () => import('@/views/billmanage/updatePrice.vue'),
        meta: { title: '账单管理 · updatePrice', legacyPath: '/hp-cloud/html/billmanage/updatePrice.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billmanage' }
      },
    ]
  },
  {
    path: '/carbrand',
    name: 'CarbrandModule',
    component: Layout,
    redirect: '/carbrand/edit',
    meta: { title: '车辆品牌', module: 'carbrand' },
    children: [
      {
        path: 'edit',
        name: 'CarbrandEdit',
        component: () => import('@/views/carbrand/edit.vue'),
        meta: { title: '车辆品牌 · 新增/编辑', legacyPath: '/hp-cloud/html/carbrand/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'carbrand' }
      },
      {
        path: 'query',
        name: 'CarbrandQuery',
        component: () => import('@/views/carbrand/query.vue'),
        meta: { title: '车辆品牌 · 列表查询', legacyPath: '/hp-cloud/html/carbrand/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'carbrand' }
      },
    ]
  },
  {
    path: '/paramsSetting',
    name: 'ParamsSettingModule',
    component: Layout,
    redirect: '/paramsSetting/edit',
    meta: { title: '参数设置', module: 'paramsSetting' },
    children: [
      {
        path: 'edit',
        name: 'ParamsSettingEdit',
        component: () => import('@/views/paramsSetting/edit.vue'),
        meta: { title: '参数设置 · 新增/编辑', legacyPath: '/hp-cloud/html/paramsSetting/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'paramsSetting' }
      },
    ]
  },
  {
    path: '/logmanage',
    name: 'LogmanageModule',
    component: Layout,
    redirect: '/logmanage/logDetail',
    meta: { title: '日志管理', module: 'logmanage' },
    children: [
      {
        path: 'logDetail',
        name: 'LogmanageLogDetail',
        component: () => import('@/views/logmanage/logDetail.vue'),
        meta: { title: '日志管理 · 字段', legacyPath: '/hp-cloud/html/logmanage/logDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'logmanage' }
      },
      {
        path: 'query',
        name: 'LogmanageQuery',
        component: () => import('@/views/logmanage/query.vue'),
        meta: { title: '日志管理 · 列表查询', legacyPath: '/hp-cloud/html/logmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'logmanage' }
      },
    ]
  },
  {
    path: '/faultworkordermanage',
    name: 'FaultworkordermanageModule',
    component: Layout,
    redirect: '/faultworkordermanage/orderdetail',
    meta: { title: '故障工单', module: 'faultworkordermanage' },
    children: [
      {
        path: 'orderdetail',
        name: 'FaultworkordermanageOrderdetail',
        component: () => import('@/views/faultworkordermanage/orderdetail.vue'),
        meta: { title: '故障工单 · 工单编号', legacyPath: '/hp-cloud/html/faultworkordermanage/orderdetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultworkordermanage' }
      },
      {
        path: 'query',
        name: 'FaultworkordermanageQuery',
        component: () => import('@/views/faultworkordermanage/query.vue'),
        meta: { title: '故障工单 · 列表查询', legacyPath: '/hp-cloud/html/faultworkordermanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultworkordermanage' }
      },
      {
        path: 'queryLog',
        name: 'FaultworkordermanageQueryLog',
        component: () => import('@/views/faultworkordermanage/queryLog.vue'),
        meta: { title: '故障履历', legacyPath: '/hp-cloud/html/faultworkordermanage/queryLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultworkordermanage' }
      },
    ]
  },
  {
    path: '/menumanage',
    name: 'MenumanageModule',
    component: Layout,
    redirect: '/menumanage/edit',
    meta: { title: '菜单管理', module: 'menumanage' },
    children: [
      {
        path: 'edit',
        name: 'MenumanageEdit',
        component: () => import('@/views/menumanage/edit.vue'),
        meta: { title: '菜单管理 · 新增/编辑', legacyPath: '/hp-cloud/html/menumanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'menumanage' }
      },
      {
        path: 'query',
        name: 'MenumanageQuery',
        component: () => import('@/views/menumanage/query.vue'),
        meta: { title: '菜单管理 · 列表查询', legacyPath: '/hp-cloud/html/menumanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'menumanage' }
      },
    ]
  },
  {
    path: '/appid',
    name: 'AppidModule',
    component: Layout,
    redirect: '/appid/addAppId',
    meta: { title: '应用ID管理', module: 'appid' },
    children: [
      {
        path: 'addAppId',
        name: 'AppidAddAppId',
        component: () => import('@/views/appid/addAppId.vue'),
        meta: { title: '应用ID管理 · addAppId', legacyPath: '/hp-cloud/html/appid/addAppId.html', complexity: 'A', migrated: true, quality: 'auto', module: 'appid' }
      },
      {
        path: 'apiLog',
        name: 'AppidApiLog',
        component: () => import('@/views/appid/apiLog.vue'),
        meta: { title: '应用ID管理 · 请求开始时间', legacyPath: '/hp-cloud/html/appid/apiLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'appid' }
      },
      {
        path: 'appGroup',
        name: 'AppidAppGroup',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '应用ID管理 · appGroup', legacyPath: '/hp-cloud/html/appid/appGroup.html', complexity: 'A', migrated: true, quality: 'frame', module: 'appid' }
      },
      {
        path: 'appIdManager',
        name: 'AppidAppIdManager',
        component: () => import('@/views/appid/appIdManager.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/appid/appIdManager.html', complexity: 'A', migrated: true, quality: 'auto', module: 'appid' }
      },
    ]
  },
  {
    path: '/unicomuser',
    name: 'UnicomuserModule',
    component: Layout,
    redirect: '/unicomuser/edit',
    meta: { title: '联通用户', module: 'unicomuser' },
    children: [
      {
        path: 'edit',
        name: 'UnicomuserEdit',
        component: () => import('@/views/unicomuser/edit.vue'),
        meta: { title: '联通用户 · 新增/编辑', legacyPath: '/hp-cloud/html/unicomuser/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'unicomuser' }
      },
      {
        path: 'query',
        name: 'UnicomuserQuery',
        component: () => import('@/views/unicomuser/query.vue'),
        meta: { title: '联通用户 · 列表查询', legacyPath: '/hp-cloud/html/unicomuser/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'unicomuser' }
      },
    ]
  },
  {
    path: '/secretkeymanager',
    name: 'SecretkeymanagerModule',
    component: Layout,
    redirect: '/secretkeymanager/list',
    meta: { title: '密钥管理', module: 'secretkeymanager' },
    children: [
      {
        path: 'list',
        name: 'SecretkeymanagerList',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '密钥管理 · 列表', legacyPath: '/hp-cloud/html/secretkeymanager/list.html', complexity: 'B', migrated: true, quality: 'frame', module: 'secretkeymanager' }
      },
    ]
  },
  {
    path: '/accumulatemanage',
    name: 'AccumulatemanageModule',
    component: Layout,
    redirect: '/accumulatemanage/editAccumulate',
    meta: { title: '累积量管理', module: 'accumulatemanage' },
    children: [
      {
        path: 'editAccumulate',
        name: 'AccumulatemanageEditAccumulate',
        component: () => import('@/views/accumulatemanage/editAccumulate.vue'),
        meta: { title: '累积量管理 · editAccumulate', legacyPath: '/hp-cloud/html/accumulatemanage/editAccumulate.html', complexity: 'A', migrated: true, quality: 'auto', module: 'accumulatemanage' }
      },
      {
        path: 'query',
        name: 'AccumulatemanageQuery',
        component: () => import('@/views/accumulatemanage/query.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/accumulatemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'accumulatemanage' }
      },
    ]
  },
  {
    path: '/userworkermanage',
    name: 'UserworkermanageModule',
    component: Layout,
    redirect: '/userworkermanage/edit',
    meta: { title: '运维人员', module: 'userworkermanage' },
    children: [
      {
        path: 'edit',
        name: 'UserworkermanageEdit',
        component: () => import('@/views/userworkermanage/edit.vue'),
        meta: { title: '运维人员 · 新增/编辑', legacyPath: '/hp-cloud/html/userworkermanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'userworkermanage' }
      },
      {
        path: 'query',
        name: 'UserworkermanageQuery',
        component: () => import('@/views/userworkermanage/query.vue'),
        meta: { title: '运维人员 · 列表查询', legacyPath: '/hp-cloud/html/userworkermanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'userworkermanage' }
      },
    ]
  },
  {
    path: '/manufacturer',
    name: 'ManufacturerModule',
    component: Layout,
    redirect: '/manufacturer/edit',
    meta: { title: '厂商管理', module: 'manufacturer' },
    children: [
      {
        path: 'edit',
        name: 'ManufacturerEdit',
        component: () => import('@/views/manufacturer/edit.vue'),
        meta: { title: '厂商管理 · 新增/编辑', legacyPath: '/hp-cloud/html/manufacturer/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'manufacturer' }
      },
      {
        path: 'query',
        name: 'ManufacturerQuery',
        component: () => import('@/views/manufacturer/query.vue'),
        meta: { title: '厂商管理 · 列表查询', legacyPath: '/hp-cloud/html/manufacturer/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'manufacturer' }
      },
    ]
  },
  {
    path: '/batchstatistics',
    name: 'BatchstatisticsModule',
    component: Layout,
    redirect: '/batchstatistics/query',
    meta: { title: '批量统计', module: 'batchstatistics' },
    children: [
      {
        path: 'query',
        name: 'BatchstatisticsQuery',
        component: () => import('@/views/batchstatistics/query.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/batchstatistics/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'batchstatistics' }
      },
      {
        path: 'queryDetail',
        name: 'BatchstatisticsQueryDetail',
        component: () => import('@/views/batchstatistics/queryDetail.vue'),
        meta: { title: '批量统计 · 明细查询', legacyPath: '/hp-cloud/html/batchstatistics/queryDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'batchstatistics' }
      },
    ]
  },
  {
    path: '/invoicemanage',
    name: 'InvoicemanageModule',
    component: Layout,
    redirect: '/invoicemanage/edit',
    meta: { title: '发票管理', module: 'invoicemanage' },
    children: [
      {
        path: 'edit',
        name: 'InvoicemanageEdit',
        component: () => import('@/views/invoicemanage/edit.vue'),
        meta: { title: '发票管理 · 新增/编辑', legacyPath: '/hp-cloud/html/invoicemanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'invoicemanage' }
      },
      {
        path: 'import',
        name: 'InvoicemanageImport',
        component: () => import('@/views/invoicemanage/import.vue'),
        meta: { title: '发票管理 · import', legacyPath: '/hp-cloud/html/invoicemanage/import.html', complexity: 'A', migrated: true, quality: 'auto', module: 'invoicemanage' }
      },
      {
        path: 'query',
        name: 'InvoicemanageQuery',
        component: () => import('@/views/invoicemanage/query.vue'),
        meta: { title: '发票管理 · 列表查询', legacyPath: '/hp-cloud/html/invoicemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'invoicemanage' }
      },
    ]
  },
  {
    path: '/messagetemplatemanage',
    name: 'MessagetemplatemanageModule',
    component: Layout,
    redirect: '/messagetemplatemanage/edit',
    meta: { title: '消息模板', module: 'messagetemplatemanage' },
    children: [
      {
        path: 'edit',
        name: 'MessagetemplatemanageEdit',
        component: () => import('@/views/messagetemplatemanage/edit.vue'),
        meta: { title: '消息模板 · 新增/编辑', legacyPath: '/hp-cloud/html/messagetemplatemanage/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'messagetemplatemanage' }
      },
      {
        path: 'preview',
        name: 'MessagetemplatemanagePreview',
        component: () => import('@/views/messagetemplatemanage/preview.vue'),
        meta: { title: '消息模板 · preview', legacyPath: '/hp-cloud/html/messagetemplatemanage/preview.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagetemplatemanage' }
      },
      {
        path: 'query',
        name: 'MessagetemplatemanageQuery',
        component: () => import('@/views/messagetemplatemanage/query.vue'),
        meta: { title: '消息模板 · 列表查询', legacyPath: '/hp-cloud/html/messagetemplatemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagetemplatemanage' }
      },
    ]
  },
  {
    path: '/balancemanager',
    name: 'BalancemanagerModule',
    component: Layout,
    redirect: '/balancemanager/query',
    meta: { title: '余额管理', module: 'balancemanager' },
    children: [
      {
        path: 'query',
        name: 'BalancemanagerQuery',
        component: () => import('@/views/balancemanager/query.vue'),
        meta: { title: '余额管理 · 列表查询', legacyPath: '/hp-cloud/html/balancemanager/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'balancemanager' }
      },
      {
        path: 'refundDetail',
        name: 'BalancemanagerRefundDetail',
        component: () => import('@/views/balancemanager/refundDetail.vue'),
        meta: { title: '余额管理 · refundDetail', legacyPath: '/hp-cloud/html/balancemanager/refundDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'balancemanager' }
      },
    ]
  },
  {
    path: '/pilemeterspower',
    name: 'PilemeterspowerModule',
    component: Layout,
    redirect: '/pilemeterspower/query',
    meta: { title: '电表功率', module: 'pilemeterspower' },
    children: [
      {
        path: 'query',
        name: 'PilemeterspowerQuery',
        component: () => import('@/views/pilemeterspower/query.vue'),
        meta: { title: '电表功率 · 列表查询', legacyPath: '/hp-cloud/html/pilemeterspower/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilemeterspower' }
      },
      {
        path: 'queryDetail',
        name: 'PilemeterspowerQueryDetail',
        component: () => import('@/views/pilemeterspower/queryDetail.vue'),
        meta: { title: '订单履历', legacyPath: '/hp-cloud/html/pilemeterspower/queryDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilemeterspower' }
      },
    ]
  },
  {
    path: '/pileapplication',
    name: 'PileapplicationModule',
    component: Layout,
    redirect: '/pileapplication/query',
    meta: { title: '充电桩申请', module: 'pileapplication' },
    children: [
      {
        path: 'query',
        name: 'PileapplicationQuery',
        component: () => import('@/views/pileapplication/query.vue'),
        meta: { title: '充电桩申请 · 列表查询', legacyPath: '/hp-cloud/html/pileapplication/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pileapplication' }
      },
    ]
  },
  {
    path: '/bookingmanage',
    name: 'BookingmanageModule',
    component: Layout,
    redirect: '/bookingmanage/query',
    meta: { title: '预约管理', module: 'bookingmanage' },
    children: [
      {
        path: 'query',
        name: 'BookingmanageQuery',
        component: () => import('@/views/bookingmanage/query.vue'),
        meta: { title: '预约管理 · 列表查询', legacyPath: '/hp-cloud/html/bookingmanage/query.html', complexity: 'B', migrated: true, quality: 'auto', module: 'bookingmanage' }
      },
      {
        path: 'queryLog',
        name: 'BookingmanageQueryLog',
        component: () => import('@/views/bookingmanage/queryLog.vue'),
        meta: { title: '订单履历', legacyPath: '/hp-cloud/html/bookingmanage/queryLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'bookingmanage' }
      },
    ]
  },
  {
    path: '/wxpushlogmanage',
    name: 'WxpushlogmanageModule',
    component: Layout,
    redirect: '/wxpushlogmanage/findDetail',
    meta: { title: '微信推送日志', module: 'wxpushlogmanage' },
    children: [
      {
        path: 'findDetail',
        name: 'WxpushlogmanageFindDetail',
        component: () => import('@/views/wxpushlogmanage/findDetail.vue'),
        meta: { title: '微信推送日志 · findDetail', legacyPath: '/hp-cloud/html/wxpushlogmanage/findDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'wxpushlogmanage' }
      },
      {
        path: 'query',
        name: 'WxpushlogmanageQuery',
        component: () => import('@/views/wxpushlogmanage/query.vue'),
        meta: { title: '微信推送日志 · 列表查询', legacyPath: '/hp-cloud/html/wxpushlogmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'wxpushlogmanage' }
      },
    ]
  },
  {
    path: '/transfermanage',
    name: 'TransfermanageModule',
    component: Layout,
    redirect: '/transfermanage/query',
    meta: { title: '转账管理', module: 'transfermanage' },
    children: [
      {
        path: 'query',
        name: 'TransfermanageQuery',
        component: () => import('@/views/transfermanage/query.vue'),
        meta: { title: '转账管理 · 列表查询', legacyPath: '/hp-cloud/html/transfermanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'transfermanage' }
      },
      {
        path: 'queryDetail',
        name: 'TransfermanageQueryDetail',
        component: () => import('@/views/transfermanage/queryDetail.vue'),
        meta: { title: '转账管理 · 明细查询', legacyPath: '/hp-cloud/html/transfermanage/queryDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'transfermanage' }
      },
    ]
  },
  {
    path: '/reportfaultmanage',
    name: 'ReportfaultmanageModule',
    component: Layout,
    redirect: '/reportfaultmanage/dealFault',
    meta: { title: '故障上报', module: 'reportfaultmanage' },
    children: [
      {
        path: 'dealFault',
        name: 'ReportfaultmanageDealFault',
        component: () => import('@/views/reportfaultmanage/dealFault.vue'),
        meta: { title: '故障上报 · dealFault', legacyPath: '/hp-cloud/html/reportfaultmanage/dealFault.html', complexity: 'A', migrated: true, quality: 'auto', module: 'reportfaultmanage' }
      },
      {
        path: 'query',
        name: 'ReportfaultmanageQuery',
        component: () => import('@/views/reportfaultmanage/query.vue'),
        meta: { title: '故障上报 · 列表查询', legacyPath: '/hp-cloud/html/reportfaultmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'reportfaultmanage' }
      },
    ]
  },
  {
    path: '/carmanage',
    name: 'CarmanageModule',
    component: Layout,
    redirect: '/carmanage/carStatistics',
    meta: { title: '车辆管理', module: 'carmanage' },
    children: [
      {
        path: 'carStatistics',
        name: 'CarmanageCarStatistics',
        component: () => import('@/views/carmanage/carStatistics.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/carmanage/carStatistics.html', complexity: 'A', migrated: true, quality: 'auto', module: 'carmanage' }
      },
      {
        path: 'editCar',
        name: 'CarmanageEditCar',
        component: () => import('@/views/carmanage/editCar.vue'),
        meta: { title: '车辆管理 · editCar', legacyPath: '/hp-cloud/html/carmanage/editCar.html', complexity: 'A', migrated: true, quality: 'auto', module: 'carmanage' }
      },
      {
        path: 'query',
        name: 'CarmanageQuery',
        component: () => import('@/views/carmanage/query.vue'),
        meta: { title: '华鹏充电桩运营平台', legacyPath: '/hp-cloud/html/carmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'carmanage' }
      },
    ]
  },
  {
    path: '/banksmanager',
    name: 'BanksmanagerModule',
    component: Layout,
    redirect: '/banksmanager/edit',
    meta: { title: '银行管理', module: 'banksmanager' },
    children: [
      {
        path: 'edit',
        name: 'BanksmanagerEdit',
        component: () => import('@/views/banksmanager/edit.vue'),
        meta: { title: '银行管理 · 新增/编辑', legacyPath: '/hp-cloud/html/banksmanager/edit.html', complexity: 'A', migrated: true, quality: 'done', module: 'banksmanager' }
      },
      {
        path: 'query',
        name: 'BanksmanagerQuery',
        component: () => import('@/views/banksmanager/query.vue'),
        meta: { title: '银行管理 · 列表查询', legacyPath: '/hp-cloud/html/banksmanager/query.html', complexity: 'A', migrated: true, quality: 'done', module: 'banksmanager' }
      },
    ]
  },
  {
    path: '/resourcemanage',
    name: 'ResourcemanageModule',
    component: Layout,
    redirect: '/resourcemanage/edit',
    meta: { title: '资源管理', module: 'resourcemanage' },
    children: [
      {
        path: 'edit',
        name: 'ResourcemanageEdit',
        component: () => import('@/views/resourcemanage/edit.vue'),
        meta: { title: '资源管理 · 新增/编辑', legacyPath: '/hp-cloud/html/resourcemanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'resourcemanage' }
      },
      {
        path: 'query',
        name: 'ResourcemanageQuery',
        component: () => import('@/views/resourcemanage/query.vue'),
        meta: { title: '资源管理 · 列表查询', legacyPath: '/hp-cloud/html/resourcemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'resourcemanage' }
      },
    ]
  },
  {
    path: '/appraisemanage',
    name: 'AppraisemanageModule',
    component: Layout,
    redirect: '/appraisemanage/query',
    meta: { title: '评价管理', module: 'appraisemanage' },
    children: [
      {
        path: 'query',
        name: 'AppraisemanageQuery',
        component: () => import('@/views/appraisemanage/query.vue'),
        meta: { title: '评价管理 · 列表查询', legacyPath: '/hp-cloud/html/appraisemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'appraisemanage' }
      },
      {
        path: 'view',
        name: 'AppraisemanageView',
        component: () => import('@/views/appraisemanage/view.vue'),
        meta: { title: '评价管理 · 查看', legacyPath: '/hp-cloud/html/appraisemanage/view.html', complexity: 'A', migrated: true, quality: 'auto', module: 'appraisemanage' }
      },
    ]
  },
  {
    path: '/appsettingmanage',
    name: 'AppsettingmanageModule',
    component: Layout,
    redirect: '/appsettingmanage/edit',
    meta: { title: '应用设置', module: 'appsettingmanage' },
    children: [
      {
        path: 'edit',
        name: 'AppsettingmanageEdit',
        component: () => import('@/views/appsettingmanage/edit.vue'),
        meta: { title: '应用设置 · 新增/编辑', legacyPath: '/hp-cloud/html/appsettingmanage/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'appsettingmanage' }
      },
      {
        path: 'query',
        name: 'AppsettingmanageQuery',
        component: () => import('@/views/appsettingmanage/query.vue'),
        meta: { title: '应用设置 · 列表查询', legacyPath: '/hp-cloud/html/appsettingmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'appsettingmanage' }
      },
      {
        path: 'query2',
        name: 'AppsettingmanageQuery2',
        component: () => import('@/views/common/LegacyFrame.vue'),
        meta: { title: '应用设置 · 名称', legacyPath: '/hp-cloud/html/appsettingmanage/query2.html', complexity: 'A', migrated: true, quality: 'frame', module: 'appsettingmanage' }
      },
    ]
  },
  {
    path: '/modulemanage',
    name: 'ModulemanageModule',
    component: Layout,
    redirect: '/modulemanage/edit',
    meta: { title: '模块管理', module: 'modulemanage' },
    children: [
      {
        path: 'edit',
        name: 'ModulemanageEdit',
        component: () => import('@/views/modulemanage/edit.vue'),
        meta: { title: '模块管理 · 新增/编辑', legacyPath: '/hp-cloud/html/modulemanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'modulemanage' }
      },
      {
        path: 'query',
        name: 'ModulemanageQuery',
        component: () => import('@/views/modulemanage/query.vue'),
        meta: { title: '模块管理 · 列表查询', legacyPath: '/hp-cloud/html/modulemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'modulemanage' }
      },
    ]
  },
  {
    path: '/rateplanmanage',
    name: 'RateplanmanageModule',
    component: Layout,
    redirect: '/rateplanmanage/query',
    meta: { title: '费率方案', module: 'rateplanmanage' },
    children: [
      {
        path: 'query',
        name: 'RateplanmanageQuery',
        component: () => import('@/views/rateplanmanage/query.vue'),
        meta: { title: '费率方案 · 列表查询', legacyPath: '/hp-cloud/html/rateplanmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'rateplanmanage' }
      },
    ]
  },
  {
    path: '/eneryctlparams',
    name: 'EneryctlparamsModule',
    component: Layout,
    redirect: '/eneryctlparams/edit',
    meta: { title: '能源控制参数', module: 'eneryctlparams' },
    children: [
      {
        path: 'edit',
        name: 'EneryctlparamsEdit',
        component: () => import('@/views/eneryctlparams/edit.vue'),
        meta: { title: '能源控制参数 · 新增/编辑', legacyPath: '/hp-cloud/html/eneryctlparams/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'eneryctlparams' }
      },
    ]
  },
  {
    path: '/commpop',
    name: 'CommpopModule',
    component: Layout,
    redirect: '/commpop/pwdChk',
    meta: { title: '通用弹窗', module: 'commpop' },
    children: [
      {
        path: 'pwdChk',
        name: 'CommpopPwdChk',
        component: () => import('@/views/commpop/pwdChk.vue'),
        meta: { title: '通用弹窗 · pwdChk', legacyPath: '/hp-cloud/html/commpop/pwdChk.html', complexity: 'A', migrated: true, quality: 'auto', module: 'commpop' }
      },
    ]
  },
]

/** 扁平页面索引：key -> 元信息（供页签、面包屑、迁移进度页使用） */
export const pageIndex: Record<string, {
  key: string
  title: string
  routePath: string
  legacyPath: string
  complexity: string
  migrated: boolean
  quality: string
  module: string
}> = {
  '_root/demo': { key: '_root/demo', title: '台账查询-按日汇总查询', routePath: '/demo', legacyPath: '/hp-cloud/html/demo.html', complexity: 'A', migrated: true, quality: 'frame', module: '_root' },
  '_root/index': { key: '_root/index', title: '华鹏充电桩运营平台-首页', routePath: '/index', legacyPath: '/hp-cloud/html/index.html', complexity: 'B', migrated: true, quality: 'done', module: '_root' },
  '_root/login': { key: '_root/login', title: '华鹏充电桩运营平台-登录', routePath: '/login', legacyPath: '/hp-cloud/html/login.html', complexity: 'A', migrated: true, quality: 'done', module: '_root' },
  '_root/systemMaintenance': { key: '_root/systemMaintenance', title: '华鹏充电桩运营平台-登录', routePath: '/systemMaintenance', legacyPath: '/hp-cloud/html/systemMaintenance.html', complexity: 'A', migrated: false, quality: '', module: '_root' },
  'sitemanage/anprDevice': { key: 'sitemanage/anprDevice', title: '站点管理 · anprDevice', routePath: '/sitemanage/anprDevice', legacyPath: '/hp-cloud/html/sitemanage/anprDevice.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/barCodeInit': { key: 'sitemanage/barCodeInit', title: '站点管理 · barCodeInit', routePath: '/sitemanage/barCodeInit', legacyPath: '/hp-cloud/html/sitemanage/barCodeInit.html', complexity: 'A', migrated: true, quality: 'done', module: 'sitemanage' },
  'sitemanage/baseadd': { key: 'sitemanage/baseadd', title: '站点管理 · 电桩ID', routePath: '/sitemanage/baseadd', legacyPath: '/hp-cloud/html/sitemanage/baseadd.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/basetab': { key: 'sitemanage/basetab', title: '站点管理 · basetab', routePath: '/sitemanage/basetab', legacyPath: '/hp-cloud/html/sitemanage/basetab.html', complexity: 'C', migrated: true, quality: 'frame', module: 'sitemanage' },
  'sitemanage/changeGroup': { key: 'sitemanage/changeGroup', title: '站点管理 · 站点名称', routePath: '/sitemanage/changeGroup', legacyPath: '/hp-cloud/html/sitemanage/changeGroup.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/chargeSuccessStatistics': { key: 'sitemanage/chargeSuccessStatistics', title: '站点管理 · chargeSuccessStatistics', routePath: '/sitemanage/chargeSuccessStatistics', legacyPath: '/hp-cloud/html/sitemanage/chargeSuccessStatistics.html', complexity: 'B', migrated: true, quality: 'frame', module: 'sitemanage' },
  'sitemanage/chargingUser': { key: 'sitemanage/chargingUser', title: '站点管理 · 日期', routePath: '/sitemanage/chargingUser', legacyPath: '/hp-cloud/html/sitemanage/chargingUser.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/chooseShareprofit': { key: 'sitemanage/chooseShareprofit', title: '华鹏充电桩运营平台', routePath: '/sitemanage/chooseShareprofit', legacyPath: '/hp-cloud/html/sitemanage/chooseShareprofit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/costAnalysis': { key: 'sitemanage/costAnalysis', title: '站点管理 · 日期', routePath: '/sitemanage/costAnalysis', legacyPath: '/hp-cloud/html/sitemanage/costAnalysis.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/cpVoltageStatistics': { key: 'sitemanage/cpVoltageStatistics', title: '站点管理 · cpVoltageStatistics', routePath: '/sitemanage/cpVoltageStatistics', legacyPath: '/hp-cloud/html/sitemanage/cpVoltageStatistics.html', complexity: 'B', migrated: true, quality: 'frame', module: 'sitemanage' },
  'sitemanage/editLockName': { key: 'sitemanage/editLockName', title: '站点管理 · editLockName', routePath: '/sitemanage/editLockName', legacyPath: '/hp-cloud/html/sitemanage/editLockName.html', complexity: 'A', migrated: true, quality: 'frame', module: 'sitemanage' },
  'sitemanage/gateway': { key: 'sitemanage/gateway', title: '站点管理 · 地锁名称', routePath: '/sitemanage/gateway', legacyPath: '/hp-cloud/html/sitemanage/gateway.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/groupLock': { key: 'sitemanage/groupLock', title: '站点管理 · 电桩ID', routePath: '/sitemanage/groupLock', legacyPath: '/hp-cloud/html/sitemanage/groupLock.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/gunList': { key: 'sitemanage/gunList', title: '站点管理 · 电桩ID', routePath: '/sitemanage/gunList', legacyPath: '/hp-cloud/html/sitemanage/gunList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/heartJsonData': { key: 'sitemanage/heartJsonData', title: '故障履历', routePath: '/sitemanage/heartJsonData', legacyPath: '/hp-cloud/html/sitemanage/heartJsonData.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/lookBase': { key: 'sitemanage/lookBase', title: '站点管理 · lookBase', routePath: '/sitemanage/lookBase', legacyPath: '/hp-cloud/html/sitemanage/lookBase.html', complexity: 'C', migrated: true, quality: 'frame', module: 'sitemanage' },
  'sitemanage/lookBaseNew': { key: 'sitemanage/lookBaseNew', title: '站点管理 · lookBaseNew', routePath: '/sitemanage/lookBaseNew', legacyPath: '/hp-cloud/html/sitemanage/lookBaseNew.html', complexity: 'A', migrated: false, quality: '', module: 'sitemanage' },
  'sitemanage/lookBaseOld': { key: 'sitemanage/lookBaseOld', title: '站点管理 · lookBaseOld', routePath: '/sitemanage/lookBaseOld', legacyPath: '/hp-cloud/html/sitemanage/lookBaseOld.html', complexity: 'C', migrated: true, quality: 'frame', module: 'sitemanage' },
  'sitemanage/monitorboard': { key: 'sitemanage/monitorboard', title: '站点管理 · 监控看板', routePath: '/sitemanage/monitorboard', legacyPath: '/hp-cloud/html/sitemanage/monitorboard.html', complexity: 'C', migrated: true, quality: 'frame', module: 'sitemanage' },
  'sitemanage/normal': { key: 'sitemanage/normal', title: '站点管理 · 常规看板', routePath: '/sitemanage/normal', legacyPath: '/hp-cloud/html/sitemanage/normal.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/operationsAnalysis': { key: 'sitemanage/operationsAnalysis', title: '站点管理 · operationsAnalysis', routePath: '/sitemanage/operationsAnalysis', legacyPath: '/hp-cloud/html/sitemanage/operationsAnalysis.html', complexity: 'B', migrated: true, quality: 'frame', module: 'sitemanage' },
  'sitemanage/photovoltaicSys': { key: 'sitemanage/photovoltaicSys', title: '华鹏充电桩运营平台', routePath: '/sitemanage/photovoltaicSys', legacyPath: '/hp-cloud/html/sitemanage/photovoltaicSys.html', complexity: 'C', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/pileList': { key: 'sitemanage/pileList', title: '站点管理 · 设备组番号', routePath: '/sitemanage/pileList', legacyPath: '/hp-cloud/html/sitemanage/pileList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/query': { key: 'sitemanage/query', title: '站点管理 · 列表查询', routePath: '/sitemanage/query', legacyPath: '/hp-cloud/html/sitemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/queryChargLog': { key: 'sitemanage/queryChargLog', title: '站点管理 · 充电桩分类', routePath: '/sitemanage/queryChargLog', legacyPath: '/hp-cloud/html/sitemanage/queryChargLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/queryCodeHash': { key: 'sitemanage/queryCodeHash', title: '站点管理 · 桩ID', routePath: '/sitemanage/queryCodeHash', legacyPath: '/hp-cloud/html/sitemanage/queryCodeHash.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/queryDateTimeLog': { key: 'sitemanage/queryDateTimeLog', title: '站点管理 · 充电桩分类', routePath: '/sitemanage/queryDateTimeLog', legacyPath: '/hp-cloud/html/sitemanage/queryDateTimeLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/queryMacAddList': { key: 'sitemanage/queryMacAddList', title: '华鹏充电桩运营平台', routePath: '/sitemanage/queryMacAddList', legacyPath: '/hp-cloud/html/sitemanage/queryMacAddList.html', complexity: 'C', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/queryOnlineTime': { key: 'sitemanage/queryOnlineTime', title: '站点管理 · 桩ID', routePath: '/sitemanage/queryOnlineTime', legacyPath: '/hp-cloud/html/sitemanage/queryOnlineTime.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/queryStatistics': { key: 'sitemanage/queryStatistics', title: '站点管理 · 桩ID', routePath: '/sitemanage/queryStatistics', legacyPath: '/hp-cloud/html/sitemanage/queryStatistics.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/queryUserLog': { key: 'sitemanage/queryUserLog', title: '站点管理 · 用户名', routePath: '/sitemanage/queryUserLog', legacyPath: '/hp-cloud/html/sitemanage/queryUserLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/siteCabinetDetail': { key: 'sitemanage/siteCabinetDetail', title: '华鹏充电桩运营平台', routePath: '/sitemanage/siteCabinetDetail', legacyPath: '/hp-cloud/html/sitemanage/siteCabinetDetail.html', complexity: 'C', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/siteCharging': { key: 'sitemanage/siteCharging', title: '站点管理 · 日期', routePath: '/sitemanage/siteCharging', legacyPath: '/hp-cloud/html/sitemanage/siteCharging.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/siteChargingNew': { key: 'sitemanage/siteChargingNew', title: '站点管理 · siteChargingNew', routePath: '/sitemanage/siteChargingNew', legacyPath: '/hp-cloud/html/sitemanage/siteChargingNew.html', complexity: 'C', migrated: true, quality: 'frame', module: 'sitemanage' },
  'sitemanage/siteChargingNum': { key: 'sitemanage/siteChargingNum', title: '站点管理 · 日期', routePath: '/sitemanage/siteChargingNum', legacyPath: '/hp-cloud/html/sitemanage/siteChargingNum.html', complexity: 'B', migrated: true, quality: 'auto', module: 'sitemanage' },
  'sitemanage/siteChargingNumNew': { key: 'sitemanage/siteChargingNumNew', title: '站点管理 · siteChargingNumNew', routePath: '/sitemanage/siteChargingNumNew', legacyPath: '/hp-cloud/html/sitemanage/siteChargingNumNew.html', complexity: 'B', migrated: true, quality: 'frame', module: 'sitemanage' },
  'sitemanage/sitedetail': { key: 'sitemanage/sitedetail', title: '华鹏充电桩运营平台', routePath: '/sitemanage/sitedetail', legacyPath: '/hp-cloud/html/sitemanage/sitedetail.html', complexity: 'C', migrated: true, quality: 'frame', module: 'sitemanage' },
  'ordermanage/calRuleDetailtab': { key: 'ordermanage/calRuleDetailtab', title: '订单管理 · 开始时间', routePath: '/ordermanage/calRuleDetailtab', legacyPath: '/hp-cloud/html/ordermanage/calRuleDetailtab.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' },
  'ordermanage/orderAccount': { key: 'ordermanage/orderAccount', title: '订单管理 · 类型', routePath: '/ordermanage/orderAccount', legacyPath: '/hp-cloud/html/ordermanage/orderAccount.html', complexity: 'A', migrated: true, quality: 'frame', module: 'ordermanage' },
  'ordermanage/orderCharging': { key: 'ordermanage/orderCharging', title: '订单管理 · 日期', routePath: '/ordermanage/orderCharging', legacyPath: '/hp-cloud/html/ordermanage/orderCharging.html', complexity: 'B', migrated: true, quality: 'auto', module: 'ordermanage' },
  'ordermanage/orderCount': { key: 'ordermanage/orderCount', title: '订单管理 · 日期', routePath: '/ordermanage/orderCount', legacyPath: '/hp-cloud/html/ordermanage/orderCount.html', complexity: 'B', migrated: true, quality: 'auto', module: 'ordermanage' },
  'ordermanage/orderIncome': { key: 'ordermanage/orderIncome', title: '订单管理 · 日期', routePath: '/ordermanage/orderIncome', legacyPath: '/hp-cloud/html/ordermanage/orderIncome.html', complexity: 'B', migrated: true, quality: 'auto', module: 'ordermanage' },
  'ordermanage/outorder/query': { key: 'ordermanage/outorder/query', title: '订单管理 · outorder · 列表查询', routePath: '/ordermanage/outorder/query', legacyPath: '/hp-cloud/html/ordermanage/outorder/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' },
  'ordermanage/parking/query': { key: 'ordermanage/parking/query', title: '订单管理 · parking · 列表查询', routePath: '/ordermanage/parking/query', legacyPath: '/hp-cloud/html/ordermanage/parking/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' },
  'ordermanage/query': { key: 'ordermanage/query', title: '订单管理 · 列表查询', routePath: '/ordermanage/query', legacyPath: '/hp-cloud/html/ordermanage/query.html', complexity: 'B', migrated: true, quality: 'auto', module: 'ordermanage' },
  'ordermanage/task/query': { key: 'ordermanage/task/query', title: '订单管理 · task · 列表查询', routePath: '/ordermanage/task/query', legacyPath: '/hp-cloud/html/ordermanage/task/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' },
  'ordermanage/queryDetail': { key: 'ordermanage/queryDetail', title: '订单管理 · 明细查询', routePath: '/ordermanage/queryDetail', legacyPath: '/hp-cloud/html/ordermanage/queryDetail.html', complexity: 'C', migrated: true, quality: 'auto', module: 'ordermanage' },
  'ordermanage/queryInvoice': { key: 'ordermanage/queryInvoice', title: '订单管理 · queryInvoice', routePath: '/ordermanage/queryInvoice', legacyPath: '/hp-cloud/html/ordermanage/queryInvoice.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' },
  'ordermanage/queryOrderLog': { key: 'ordermanage/queryOrderLog', title: '订单履历', routePath: '/ordermanage/queryOrderLog', legacyPath: '/hp-cloud/html/ordermanage/queryOrderLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' },
  'ordermanage/recharge': { key: 'ordermanage/recharge', title: '订单管理 · recharge', routePath: '/ordermanage/recharge', legacyPath: '/hp-cloud/html/ordermanage/recharge.html', complexity: 'A', migrated: true, quality: 'auto', module: 'ordermanage' },
  'dashboard/bigscreenNew': { key: 'dashboard/bigscreenNew', title: '数据看板 · 可视化大屏', routePath: '/dashboard/bigscreenNew', legacyPath: '/hp-cloud/html/dashboard/bigscreenNew.html', complexity: 'C', migrated: true, quality: 'done', module: 'dashboard' },
  'dashboard/groupDetailMap': { key: 'dashboard/groupDetailMap', title: '数据看板 · 站点分布明细', routePath: '/dashboard/groupDetailMap', legacyPath: '/hp-cloud/html/dashboard/groupDetailMap.html', complexity: 'C', migrated: true, quality: 'frame', module: 'dashboard' },
  'dashboard/groupMap': { key: 'dashboard/groupMap', title: '数据看板 · 站点分布图', routePath: '/dashboard/groupMap', legacyPath: '/hp-cloud/html/dashboard/groupMap.html', complexity: 'C', migrated: true, quality: 'frame', module: 'dashboard' },
  'dashboard/normal': { key: 'dashboard/normal', title: '数据看板 · 常规看板', routePath: '/dashboard/normal', legacyPath: '/hp-cloud/html/dashboard/normal.html', complexity: 'C', migrated: true, quality: 'frame', module: 'dashboard' },
  'dashboard/offlineCountMonitor': { key: 'dashboard/offlineCountMonitor', title: '数据看板 · 离线统计监控', routePath: '/dashboard/offlineCountMonitor', legacyPath: '/hp-cloud/html/dashboard/offlineCountMonitor.html', complexity: 'A', migrated: true, quality: 'auto', module: 'dashboard' },
  'dashboard/offlineMonitor': { key: 'dashboard/offlineMonitor', title: '数据看板 · 离线监控', routePath: '/dashboard/offlineMonitor', legacyPath: '/hp-cloud/html/dashboard/offlineMonitor.html', complexity: 'A', migrated: true, quality: 'auto', module: 'dashboard' },
  'dashboard/siteMonitorMapCluster': { key: 'dashboard/siteMonitorMapCluster', title: '数据看板 · 站点聚合地图', routePath: '/dashboard/siteMonitorMapCluster', legacyPath: '/hp-cloud/html/dashboard/siteMonitorMapCluster.html', complexity: 'C', migrated: true, quality: 'frame', module: 'dashboard' },
  'pilesync/calRuleDetail': { key: 'pilesync/calRuleDetail', title: '充电桩同步 · 类别', routePath: '/pilesync/calRuleDetail', legacyPath: '/hp-cloud/html/pilesync/calRuleDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' },
  'pilesync/offlineQueryLog': { key: 'pilesync/offlineQueryLog', title: '充电桩同步 · 桩ID', routePath: '/pilesync/offlineQueryLog', legacyPath: '/hp-cloud/html/pilesync/offlineQueryLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' },
  'pilesync/pileOptLog': { key: 'pilesync/pileOptLog', title: '充电桩同步 · 桩ID', routePath: '/pilesync/pileOptLog', legacyPath: '/hp-cloud/html/pilesync/pileOptLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' },
  'pilesync/queryCalRule': { key: 'pilesync/queryCalRule', title: '充电桩同步 · 选择', routePath: '/pilesync/queryCalRule', legacyPath: '/hp-cloud/html/pilesync/queryCalRule.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' },
  'pilesync/queryCalRuleList': { key: 'pilesync/queryCalRuleList', title: '充电桩同步 · 桩编号', routePath: '/pilesync/queryCalRuleList', legacyPath: '/hp-cloud/html/pilesync/queryCalRuleList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'pilesync' },
  'pilesync/queryDtuList': { key: 'pilesync/queryDtuList', title: '充电桩同步 · 桩编号', routePath: '/pilesync/queryDtuList', legacyPath: '/hp-cloud/html/pilesync/queryDtuList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'pilesync' },
  'pilesync/queryIpList': { key: 'pilesync/queryIpList', title: '充电桩同步 · 桩编号', routePath: '/pilesync/queryIpList', legacyPath: '/hp-cloud/html/pilesync/queryIpList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'pilesync' },
  'pilesync/queryOfflineList': { key: 'pilesync/queryOfflineList', title: '充电桩同步 · 桩编号', routePath: '/pilesync/queryOfflineList', legacyPath: '/hp-cloud/html/pilesync/queryOfflineList.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' },
  'pilesync/queryProgram': { key: 'pilesync/queryProgram', title: '充电桩同步 · 选择', routePath: '/pilesync/queryProgram', legacyPath: '/hp-cloud/html/pilesync/queryProgram.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' },
  'pilesync/queryProgramList': { key: 'pilesync/queryProgramList', title: '充电桩同步 · 桩ID', routePath: '/pilesync/queryProgramList', legacyPath: '/hp-cloud/html/pilesync/queryProgramList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'pilesync' },
  'pilesync/queryProgramSycnLog': { key: 'pilesync/queryProgramSycnLog', title: '充电桩同步 · 桩编号', routePath: '/pilesync/queryProgramSycnLog', legacyPath: '/hp-cloud/html/pilesync/queryProgramSycnLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' },
  'pilesync/queryTrader': { key: 'pilesync/queryTrader', title: '充电桩同步 · 选择', routePath: '/pilesync/queryTrader', legacyPath: '/hp-cloud/html/pilesync/queryTrader.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' },
  'pilesync/queryTraderList': { key: 'pilesync/queryTraderList', title: '充电桩同步 · 桩编号', routePath: '/pilesync/queryTraderList', legacyPath: '/hp-cloud/html/pilesync/queryTraderList.html', complexity: 'B', migrated: true, quality: 'auto', module: 'pilesync' },
  'pilesync/settingSysIp': { key: 'pilesync/settingSysIp', title: '充电桩同步 · settingSysIp', routePath: '/pilesync/settingSysIp', legacyPath: '/hp-cloud/html/pilesync/settingSysIp.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilesync' },
  'monitorboard/edit': { key: 'monitorboard/edit', title: '监控看板 · 新增/编辑', routePath: '/monitorboard/edit', legacyPath: '/hp-cloud/html/monitorboard/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'monitorboard' },
  'monitorboard/editType': { key: 'monitorboard/editType', title: '监控看板 · editType', routePath: '/monitorboard/editType', legacyPath: '/hp-cloud/html/monitorboard/editType.html', complexity: 'A', migrated: true, quality: 'auto', module: 'monitorboard' },
  'monitorboard/playback': { key: 'monitorboard/playback', title: '视频监控回放 - 华鹏充电桩运营管理平台', routePath: '/monitorboard/playback', legacyPath: '/hp-cloud/html/monitorboard/playback.html', complexity: 'C', migrated: true, quality: 'frame', module: 'monitorboard' },
  'monitorboard/query': { key: 'monitorboard/query', title: '监控看板 · 列表查询', routePath: '/monitorboard/query', legacyPath: '/hp-cloud/html/monitorboard/query.html', complexity: 'C', migrated: true, quality: 'frame', module: 'monitorboard' },
  'monitorboard/queryList': { key: 'monitorboard/queryList', title: '监控看板 · queryList', routePath: '/monitorboard/queryList', legacyPath: '/hp-cloud/html/monitorboard/queryList.html', complexity: 'A', migrated: true, quality: 'auto', module: 'monitorboard' },
  'monitorboard/queryType': { key: 'monitorboard/queryType', title: '监控看板 · queryType', routePath: '/monitorboard/queryType', legacyPath: '/hp-cloud/html/monitorboard/queryType.html', complexity: 'A', migrated: true, quality: 'auto', module: 'monitorboard' },
  'storageenergy/edit': { key: 'storageenergy/edit', title: '储能管理 · 新增/编辑', routePath: '/storageenergy/edit', legacyPath: '/hp-cloud/html/storageenergy/edit.html', complexity: 'C', migrated: true, quality: 'frame', module: 'storageenergy' },
  'storageenergy/lookBase': { key: 'storageenergy/lookBase', title: '储能管理 · lookBase', routePath: '/storageenergy/lookBase', legacyPath: '/hp-cloud/html/storageenergy/lookBase.html', complexity: 'C', migrated: true, quality: 'frame', module: 'storageenergy' },
  'storageenergy/monitorboard': { key: 'storageenergy/monitorboard', title: '储能管理 · 监控看板', routePath: '/storageenergy/monitorboard', legacyPath: '/hp-cloud/html/storageenergy/monitorboard.html', complexity: 'C', migrated: true, quality: 'frame', module: 'storageenergy' },
  'storageenergy/query': { key: 'storageenergy/query', title: '储能管理 · 列表查询', routePath: '/storageenergy/query', legacyPath: '/hp-cloud/html/storageenergy/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'storageenergy' },
  'calrule/edit': { key: 'calrule/edit', title: '计费规则 · 新增/编辑', routePath: '/calrule/edit', legacyPath: '/hp-cloud/html/calrule/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'calrule' },
  'calrule/pop': { key: 'calrule/pop', title: '计费规则 · pop', routePath: '/calrule/pop', legacyPath: '/hp-cloud/html/calrule/pop.html', complexity: 'A', migrated: true, quality: 'frame', module: 'calrule' },
  'calrule/query': { key: 'calrule/query', title: '计费规则 · 列表查询', routePath: '/calrule/query', legacyPath: '/hp-cloud/html/calrule/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'calrule' },
  'usermanage/accumulate': { key: 'usermanage/accumulate', title: '用户管理 · 用户ID', routePath: '/usermanage/accumulate', legacyPath: '/hp-cloud/html/usermanage/accumulate.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' },
  'usermanage/addEmployee': { key: 'usermanage/addEmployee', title: '用户管理 · 新增员工', routePath: '/usermanage/addEmployee', legacyPath: '/hp-cloud/html/usermanage/addEmployee.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' },
  'usermanage/application': { key: 'usermanage/application', title: '华鹏充电桩运营平台', routePath: '/usermanage/application', legacyPath: '/hp-cloud/html/usermanage/application.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' },
  'usermanage/changePwd': { key: 'usermanage/changePwd', title: '用户管理 · changePwd', routePath: '/usermanage/changePwd', legacyPath: '/hp-cloud/html/usermanage/changePwd.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' },
  'usermanage/edit': { key: 'usermanage/edit', title: '用户管理 · 新增/编辑', routePath: '/usermanage/edit', legacyPath: '/hp-cloud/html/usermanage/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'usermanage' },
  'usermanage/employee': { key: 'usermanage/employee', title: '用户管理 · 员工用户名', routePath: '/usermanage/employee', legacyPath: '/hp-cloud/html/usermanage/employee.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' },
  'usermanage/lockOpt': { key: 'usermanage/lockOpt', title: '用户管理 · lockOpt', routePath: '/usermanage/lockOpt', legacyPath: '/hp-cloud/html/usermanage/lockOpt.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' },
  'usermanage/query': { key: 'usermanage/query', title: '用户管理 · 列表查询', routePath: '/usermanage/query', legacyPath: '/hp-cloud/html/usermanage/query.html', complexity: 'B', migrated: true, quality: 'done', module: 'usermanage' },
  'usermanage/queryCompanyInfo': { key: 'usermanage/queryCompanyInfo', title: '用户管理 · 企业信息', routePath: '/usermanage/queryCompanyInfo', legacyPath: '/hp-cloud/html/usermanage/queryCompanyInfo.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' },
  'usermanage/queryOperatingRecord': { key: 'usermanage/queryOperatingRecord', title: '用户管理 · 操作记录', routePath: '/usermanage/queryOperatingRecord', legacyPath: '/hp-cloud/html/usermanage/queryOperatingRecord.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' },
  'usermanage/queryUserRole': { key: 'usermanage/queryUserRole', title: '用户管理 · 用户角色', routePath: '/usermanage/queryUserRole', legacyPath: '/hp-cloud/html/usermanage/queryUserRole.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' },
  'usermanage/recharge': { key: 'usermanage/recharge', title: '用户管理 · recharge', routePath: '/usermanage/recharge', legacyPath: '/hp-cloud/html/usermanage/recharge.html', complexity: 'A', migrated: true, quality: 'auto', module: 'usermanage' },
  'traderuser/adduserpop': { key: 'traderuser/adduserpop', title: '华鹏充电桩运营平台', routePath: '/traderuser/adduserpop', legacyPath: '/hp-cloud/html/traderuser/adduserpop.html', complexity: 'A', migrated: true, quality: 'auto', module: 'traderuser' },
  'traderuser/chooseShareprofit': { key: 'traderuser/chooseShareprofit', title: '华鹏充电桩运营平台', routePath: '/traderuser/chooseShareprofit', legacyPath: '/hp-cloud/html/traderuser/chooseShareprofit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'traderuser' },
  'traderuser/edit': { key: 'traderuser/edit', title: '商户用户 · 新增/编辑', routePath: '/traderuser/edit', legacyPath: '/hp-cloud/html/traderuser/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'traderuser' },
  'traderuser/query': { key: 'traderuser/query', title: '商户用户 · 列表查询', routePath: '/traderuser/query', legacyPath: '/hp-cloud/html/traderuser/query.html', complexity: 'B', migrated: true, quality: 'auto', module: 'traderuser' },
  'traderuser/userpop': { key: 'traderuser/userpop', title: '华鹏充电桩运营平台', routePath: '/traderuser/userpop', legacyPath: '/hp-cloud/html/traderuser/userpop.html', complexity: 'A', migrated: true, quality: 'auto', module: 'traderuser' },
  'chargelists/chargedetail': { key: 'chargelists/chargedetail', title: '华鹏充电桩运营平台', routePath: '/chargelists/chargedetail', legacyPath: '/hp-cloud/html/chargelists/chargedetail.html', complexity: 'C', migrated: true, quality: 'frame', module: 'chargelists' },
  'chargelists/chargelists': { key: 'chargelists/chargelists', title: '华鹏充电桩运营平台', routePath: '/chargelists/chargelists', legacyPath: '/hp-cloud/html/chargelists/chargelists.html', complexity: 'B', migrated: true, quality: 'frame', module: 'chargelists' },
  'chargelists/sitedetail': { key: 'chargelists/sitedetail', title: '华鹏充电桩运营平台', routePath: '/chargelists/sitedetail', legacyPath: '/hp-cloud/html/chargelists/sitedetail.html', complexity: 'C', migrated: true, quality: 'frame', module: 'chargelists' },
  'billtaskmanage/addBillTask': { key: 'billtaskmanage/addBillTask', title: '对账任务 · addBillTask', routePath: '/billtaskmanage/addBillTask', legacyPath: '/hp-cloud/html/billtaskmanage/addBillTask.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billtaskmanage' },
  'billtaskmanage/assignUser': { key: 'billtaskmanage/assignUser', title: '对账任务 · assignUser', routePath: '/billtaskmanage/assignUser', legacyPath: '/hp-cloud/html/billtaskmanage/assignUser.html', complexity: 'A', migrated: true, quality: 'frame', module: 'billtaskmanage' },
  'billtaskmanage/balanceBill': { key: 'billtaskmanage/balanceBill', title: '对账任务 · balanceBill', routePath: '/billtaskmanage/balanceBill', legacyPath: '/hp-cloud/html/billtaskmanage/balanceBill.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billtaskmanage' },
  'billtaskmanage/confirm': { key: 'billtaskmanage/confirm', title: '对账任务 · confirm', routePath: '/billtaskmanage/confirm', legacyPath: '/hp-cloud/html/billtaskmanage/confirm.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billtaskmanage' },
  'billtaskmanage/query': { key: 'billtaskmanage/query', title: '对账任务 · 列表查询', routePath: '/billtaskmanage/query', legacyPath: '/hp-cloud/html/billtaskmanage/query.html', complexity: 'B', migrated: true, quality: 'auto', module: 'billtaskmanage' },
  'billtaskmanage/queryDetail': { key: 'billtaskmanage/queryDetail', title: '对账任务 · 明细查询', routePath: '/billtaskmanage/queryDetail', legacyPath: '/hp-cloud/html/billtaskmanage/queryDetail.html', complexity: 'B', migrated: true, quality: 'auto', module: 'billtaskmanage' },
  'billtaskmanage/queryMonthBill': { key: 'billtaskmanage/queryMonthBill', title: '对账任务 · 日期', routePath: '/billtaskmanage/queryMonthBill', legacyPath: '/hp-cloud/html/billtaskmanage/queryMonthBill.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billtaskmanage' },
  'billtaskmanage/queryOrderList': { key: 'billtaskmanage/queryOrderList', title: '对账任务 · 用户', routePath: '/billtaskmanage/queryOrderList', legacyPath: '/hp-cloud/html/billtaskmanage/queryOrderList.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billtaskmanage' },
  'billtaskmanage/queryUserMonthBill': { key: 'billtaskmanage/queryUserMonthBill', title: '对账任务 · 日期', routePath: '/billtaskmanage/queryUserMonthBill', legacyPath: '/hp-cloud/html/billtaskmanage/queryUserMonthBill.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billtaskmanage' },
  'billtaskmanage/selectBillMonth': { key: 'billtaskmanage/selectBillMonth', title: '对账任务 · selectBillMonth', routePath: '/billtaskmanage/selectBillMonth', legacyPath: '/hp-cloud/html/billtaskmanage/selectBillMonth.html', complexity: 'A', migrated: true, quality: 'frame', module: 'billtaskmanage' },
  'iccard/application': { key: 'iccard/application', title: '华鹏充电桩运营平台', routePath: '/iccard/application', legacyPath: '/hp-cloud/html/iccard/application.html', complexity: 'A', migrated: true, quality: 'auto', module: 'iccard' },
  'iccard/edit': { key: 'iccard/edit', title: 'IC卡管理 · 新增/编辑', routePath: '/iccard/edit', legacyPath: '/hp-cloud/html/iccard/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'iccard' },
  'iccard/pileBind': { key: 'iccard/pileBind', title: 'IC卡管理 · pileBind', routePath: '/iccard/pileBind', legacyPath: '/hp-cloud/html/iccard/pileBind.html', complexity: 'B', migrated: true, quality: 'auto', module: 'iccard' },
  'iccard/query': { key: 'iccard/query', title: '华鹏充电桩运营平台', routePath: '/iccard/query', legacyPath: '/hp-cloud/html/iccard/query.html', complexity: 'C', migrated: true, quality: 'auto', module: 'iccard' },
  'iccard/queryLog': { key: 'iccard/queryLog', title: '华鹏充电桩运营平台', routePath: '/iccard/queryLog', legacyPath: '/hp-cloud/html/iccard/queryLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'iccard' },
  'iccard/userpop': { key: 'iccard/userpop', title: '华鹏充电桩运营平台', routePath: '/iccard/userpop', legacyPath: '/hp-cloud/html/iccard/userpop.html', complexity: 'A', migrated: true, quality: 'auto', module: 'iccard' },
  'factorysetting/barCodeInit': { key: 'factorysetting/barCodeInit', title: '出厂设置 · barCodeInit', routePath: '/factorysetting/barCodeInit', legacyPath: '/hp-cloud/html/factorysetting/barCodeInit.html', complexity: 'A', migrated: true, quality: 'frame', module: 'factorysetting' },
  'factorysetting/boundGun': { key: 'factorysetting/boundGun', title: '出厂设置 · 电桩ID', routePath: '/factorysetting/boundGun', legacyPath: '/hp-cloud/html/factorysetting/boundGun.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' },
  'factorysetting/boundLock': { key: 'factorysetting/boundLock', title: '出厂设置 · 网关名称', routePath: '/factorysetting/boundLock', legacyPath: '/hp-cloud/html/factorysetting/boundLock.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' },
  'factorysetting/editGun': { key: 'factorysetting/editGun', title: '出厂设置 · editGun', routePath: '/factorysetting/editGun', legacyPath: '/hp-cloud/html/factorysetting/editGun.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' },
  'factorysetting/editPile': { key: 'factorysetting/editPile', title: '出厂设置 · editPile', routePath: '/factorysetting/editPile', legacyPath: '/hp-cloud/html/factorysetting/editPile.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' },
  'factorysetting/import': { key: 'factorysetting/import', title: '出厂设置 · import', routePath: '/factorysetting/import', legacyPath: '/hp-cloud/html/factorysetting/import.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' },
  'factorysetting/lock': { key: 'factorysetting/lock', title: '出厂设置 · lock', routePath: '/factorysetting/lock', legacyPath: '/hp-cloud/html/factorysetting/lock.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' },
  'factorysetting/pileInitialize': { key: 'factorysetting/pileInitialize', title: '出厂设置 · 桩ID', routePath: '/factorysetting/pileInitialize', legacyPath: '/hp-cloud/html/factorysetting/pileInitialize.html', complexity: 'B', migrated: true, quality: 'auto', module: 'factorysetting' },
  'factorysetting/query': { key: 'factorysetting/query', title: '出厂设置 · 列表查询', routePath: '/factorysetting/query', legacyPath: '/hp-cloud/html/factorysetting/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'factorysetting' },
  'faultmanage/faultDetail': { key: 'faultmanage/faultDetail', title: '故障管理 · faultDetail', routePath: '/faultmanage/faultDetail', legacyPath: '/hp-cloud/html/faultmanage/faultDetail.html', complexity: 'B', migrated: true, quality: 'auto', module: 'faultmanage' },
  'faultmanage/levelQuery': { key: 'faultmanage/levelQuery', title: '故障管理 · levelQuery', routePath: '/faultmanage/levelQuery', legacyPath: '/hp-cloud/html/faultmanage/levelQuery.html', complexity: 'A', migrated: true, quality: 'frame', module: 'faultmanage' },
  'faultmanage/queryDetail': { key: 'faultmanage/queryDetail', title: '故障管理 · 明细查询', routePath: '/faultmanage/queryDetail', legacyPath: '/hp-cloud/html/faultmanage/queryDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultmanage' },
  'faultmanage/queryLog': { key: 'faultmanage/queryLog', title: '故障履历', routePath: '/faultmanage/queryLog', legacyPath: '/hp-cloud/html/faultmanage/queryLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultmanage' },
  'faultmanage/startWorkOrder': { key: 'faultmanage/startWorkOrder', title: '故障管理 · startWorkOrder', routePath: '/faultmanage/startWorkOrder', legacyPath: '/hp-cloud/html/faultmanage/startWorkOrder.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultmanage' },
  'faultmanage/statusQuery': { key: 'faultmanage/statusQuery', title: '故障管理 · statusQuery', routePath: '/faultmanage/statusQuery', legacyPath: '/hp-cloud/html/faultmanage/statusQuery.html', complexity: 'B', migrated: true, quality: 'frame', module: 'faultmanage' },
  'mastercode/editError': { key: 'mastercode/editError', title: '主数据字典 · editError', routePath: '/mastercode/editError', legacyPath: '/hp-cloud/html/mastercode/editError.html', complexity: 'A', migrated: true, quality: 'auto', module: 'mastercode' },
  'mastercode/operationsAnalysis': { key: 'mastercode/operationsAnalysis', title: '主数据字典 · 用户', routePath: '/mastercode/operationsAnalysis', legacyPath: '/hp-cloud/html/mastercode/operationsAnalysis.html', complexity: 'B', migrated: true, quality: 'auto', module: 'mastercode' },
  'mastercode/query': { key: 'mastercode/query', title: '主数据字典 · 列表查询', routePath: '/mastercode/query', legacyPath: '/hp-cloud/html/mastercode/query.html', complexity: 'B', migrated: true, quality: 'auto', module: 'mastercode' },
  'mastercode/queryError': { key: 'mastercode/queryError', title: '主数据字典 · 异常原因名称', routePath: '/mastercode/queryError', legacyPath: '/hp-cloud/html/mastercode/queryError.html', complexity: 'A', migrated: true, quality: 'auto', module: 'mastercode' },
  'tools/addstandaloneprogram': { key: 'tools/addstandaloneprogram', title: '工具箱 · addstandaloneprogram', routePath: '/tools/addstandaloneprogram', legacyPath: '/hp-cloud/html/tools/addstandaloneprogram.html', complexity: 'A', migrated: true, quality: 'auto', module: 'tools' },
  'tools/addwhiteblack': { key: 'tools/addwhiteblack', title: '工具箱 · addwhiteblack', routePath: '/tools/addwhiteblack', legacyPath: '/hp-cloud/html/tools/addwhiteblack.html', complexity: 'A', migrated: true, quality: 'auto', module: 'tools' },
  'tools/chargelimitresetquery': { key: 'tools/chargelimitresetquery', title: '工具箱 · 订单号', routePath: '/tools/chargelimitresetquery', legacyPath: '/hp-cloud/html/tools/chargelimitresetquery.html', complexity: 'A', migrated: true, quality: 'frame', module: 'tools' },
  'tools/standalonedetail': { key: 'tools/standalonedetail', title: '工具箱 · standalonedetail', routePath: '/tools/standalonedetail', legacyPath: '/hp-cloud/html/tools/standalonedetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'tools' },
  'tools/standalonequery': { key: 'tools/standalonequery', title: '工具箱 · 组织名称', routePath: '/tools/standalonequery', legacyPath: '/hp-cloud/html/tools/standalonequery.html', complexity: 'A', migrated: true, quality: 'auto', module: 'tools' },
  'tools/whiteblackquery': { key: 'tools/whiteblackquery', title: '工具箱 · 用户名/IC卡号', routePath: '/tools/whiteblackquery', legacyPath: '/hp-cloud/html/tools/whiteblackquery.html', complexity: 'A', migrated: true, quality: 'auto', module: 'tools' },
  'systemsetting/edit': { key: 'systemsetting/edit', title: '系统设置 · 新增/编辑', routePath: '/systemsetting/edit', legacyPath: '/hp-cloud/html/systemsetting/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'systemsetting' },
  'systemsetting/query': { key: 'systemsetting/query', title: '系统设置 · 列表查询', routePath: '/systemsetting/query', legacyPath: '/hp-cloud/html/systemsetting/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'systemsetting' },
  'systemsetting/shippingpop': { key: 'systemsetting/shippingpop', title: '华鹏充电桩运营平台', routePath: '/systemsetting/shippingpop', legacyPath: '/hp-cloud/html/systemsetting/shippingpop.html', complexity: 'A', migrated: true, quality: 'auto', module: 'systemsetting' },
  'transferstatistics/query': { key: 'transferstatistics/query', title: '转账统计 · 列表查询', routePath: '/transferstatistics/query', legacyPath: '/hp-cloud/html/transferstatistics/query.html', complexity: 'C', migrated: true, quality: 'auto', module: 'transferstatistics' },
  'transferstatistics/queryBillStatistics': { key: 'transferstatistics/queryBillStatistics', title: '转账统计 · 转账日期', routePath: '/transferstatistics/queryBillStatistics', legacyPath: '/hp-cloud/html/transferstatistics/queryBillStatistics.html', complexity: 'C', migrated: true, quality: 'auto', module: 'transferstatistics' },
  'companymanage/application': { key: 'companymanage/application', title: '华鹏充电桩运营平台', routePath: '/companymanage/application', legacyPath: '/hp-cloud/html/companymanage/application.html', complexity: 'B', migrated: true, quality: 'auto', module: 'companymanage' },
  'companymanage/assignGroup': { key: 'companymanage/assignGroup', title: '企业管理 · assignGroup', routePath: '/companymanage/assignGroup', legacyPath: '/hp-cloud/html/companymanage/assignGroup.html', complexity: 'A', migrated: true, quality: 'frame', module: 'companymanage' },
  'companymanage/assignInterface': { key: 'companymanage/assignInterface', title: '企业管理 · 选择', routePath: '/companymanage/assignInterface', legacyPath: '/hp-cloud/html/companymanage/assignInterface.html', complexity: 'A', migrated: true, quality: 'auto', module: 'companymanage' },
  'companymanage/queryCompanyInfo': { key: 'companymanage/queryCompanyInfo', title: '企业管理 · 企业信息', routePath: '/companymanage/queryCompanyInfo', legacyPath: '/hp-cloud/html/companymanage/queryCompanyInfo.html', complexity: 'A', migrated: true, quality: 'auto', module: 'companymanage' },
  'companymanage/secretkey': { key: 'companymanage/secretkey', title: '企业管理 · secretkey', routePath: '/companymanage/secretkey', legacyPath: '/hp-cloud/html/companymanage/secretkey.html', complexity: 'A', migrated: true, quality: 'auto', module: 'companymanage' },
  'shareprofitrule/edit': { key: 'shareprofitrule/edit', title: '分成规则 · 新增/编辑', routePath: '/shareprofitrule/edit', legacyPath: '/hp-cloud/html/shareprofitrule/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'shareprofitrule' },
  'shareprofitrule/editPop': { key: 'shareprofitrule/editPop', title: '计算机类型规则管理', routePath: '/shareprofitrule/editPop', legacyPath: '/hp-cloud/html/shareprofitrule/editPop.html', complexity: 'A', migrated: true, quality: 'frame', module: 'shareprofitrule' },
  'shareprofitrule/query': { key: 'shareprofitrule/query', title: '分成规则 · 列表查询', routePath: '/shareprofitrule/query', legacyPath: '/hp-cloud/html/shareprofitrule/query.html', complexity: 'C', migrated: true, quality: 'auto', module: 'shareprofitrule' },
  'apiinfomanage/apilog': { key: 'apiinfomanage/apilog', title: '接口信息管理 · 请求流水号', routePath: '/apiinfomanage/apilog', legacyPath: '/hp-cloud/html/apiinfomanage/apilog.html', complexity: 'B', migrated: true, quality: 'auto', module: 'apiinfomanage' },
  'apiinfomanage/edit': { key: 'apiinfomanage/edit', title: '接口信息管理 · 新增/编辑', routePath: '/apiinfomanage/edit', legacyPath: '/hp-cloud/html/apiinfomanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'apiinfomanage' },
  'apiinfomanage/loginfo': { key: 'apiinfomanage/loginfo', title: '接口信息管理 · loginfo', routePath: '/apiinfomanage/loginfo', legacyPath: '/hp-cloud/html/apiinfomanage/loginfo.html', complexity: 'A', migrated: true, quality: 'frame', module: 'apiinfomanage' },
  'apiinfomanage/query': { key: 'apiinfomanage/query', title: '接口信息管理 · 列表查询', routePath: '/apiinfomanage/query', legacyPath: '/hp-cloud/html/apiinfomanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'apiinfomanage' },
  'devicerepository/detail': { key: 'devicerepository/detail', title: '设备库 · 详情', routePath: '/devicerepository/detail', legacyPath: '/hp-cloud/html/devicerepository/detail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'devicerepository' },
  'devicerepository/edit': { key: 'devicerepository/edit', title: '设备库 · 新增/编辑', routePath: '/devicerepository/edit', legacyPath: '/hp-cloud/html/devicerepository/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'devicerepository' },
  'devicerepository/query': { key: 'devicerepository/query', title: '设备库 · 列表查询', routePath: '/devicerepository/query', legacyPath: '/hp-cloud/html/devicerepository/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'devicerepository' },
  'analysisdashboard/query': { key: 'analysisdashboard/query', title: '分析看板 · 列表查询', routePath: '/analysisdashboard/query', legacyPath: '/hp-cloud/html/analysisdashboard/query.html', complexity: 'B', migrated: true, quality: 'frame', module: 'analysisdashboard' },
  'unicomdevice/query': { key: 'unicomdevice/query', title: '联通设备 · 列表查询', routePath: '/unicomdevice/query', legacyPath: '/hp-cloud/html/unicomdevice/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'unicomdevice' },
  'unicomdevice/queryDetail': { key: 'unicomdevice/queryDetail', title: '联通设备 · 明细查询', routePath: '/unicomdevice/queryDetail', legacyPath: '/hp-cloud/html/unicomdevice/queryDetail.html', complexity: 'C', migrated: true, quality: 'auto', module: 'unicomdevice' },
  'messagemanage/edit': { key: 'messagemanage/edit', title: '消息管理 · 新增/编辑', routePath: '/messagemanage/edit', legacyPath: '/hp-cloud/html/messagemanage/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'messagemanage' },
  'messagemanage/historyQuery': { key: 'messagemanage/historyQuery', title: '消息管理 · 消息类型', routePath: '/messagemanage/historyQuery', legacyPath: '/hp-cloud/html/messagemanage/historyQuery.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagemanage' },
  'messagemanage/preview': { key: 'messagemanage/preview', title: '消息管理 · preview', routePath: '/messagemanage/preview', legacyPath: '/hp-cloud/html/messagemanage/preview.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagemanage' },
  'messagemanage/query': { key: 'messagemanage/query', title: '消息管理 · 列表查询', routePath: '/messagemanage/query', legacyPath: '/hp-cloud/html/messagemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagemanage' },
  'messagemanage/sendMessage': { key: 'messagemanage/sendMessage', title: '消息管理 · sendMessage', routePath: '/messagemanage/sendMessage', legacyPath: '/hp-cloud/html/messagemanage/sendMessage.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagemanage' },
  'messagemanage/sendUserLog': { key: 'messagemanage/sendUserLog', title: '消息管理 · 用户名', routePath: '/messagemanage/sendUserLog', legacyPath: '/hp-cloud/html/messagemanage/sendUserLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagemanage' },
  'invoicerequestmanage/invoicePreview': { key: 'invoicerequestmanage/invoicePreview', title: '发票详情', routePath: '/invoicerequestmanage/invoicePreview', legacyPath: '/hp-cloud/html/invoicerequestmanage/invoicePreview.html', complexity: 'B', migrated: true, quality: 'auto', module: 'invoicerequestmanage' },
  'invoicerequestmanage/invoiceUpload': { key: 'invoicerequestmanage/invoiceUpload', title: '开票申请 · invoiceUpload', routePath: '/invoicerequestmanage/invoiceUpload', legacyPath: '/hp-cloud/html/invoicerequestmanage/invoiceUpload.html', complexity: 'A', migrated: true, quality: 'frame', module: 'invoicerequestmanage' },
  'invoicerequestmanage/query': { key: 'invoicerequestmanage/query', title: '开票申请 · 列表查询', routePath: '/invoicerequestmanage/query', legacyPath: '/hp-cloud/html/invoicerequestmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'invoicerequestmanage' },
  'invoicerequestmanage/queryInvoice': { key: 'invoicerequestmanage/queryInvoice', title: '发票详情', routePath: '/invoicerequestmanage/queryInvoice', legacyPath: '/hp-cloud/html/invoicerequestmanage/queryInvoice.html', complexity: 'B', migrated: true, quality: 'auto', module: 'invoicerequestmanage' },
  'logsetting/logDetail': { key: 'logsetting/logDetail', title: '日志设置 · 字段名', routePath: '/logsetting/logDetail', legacyPath: '/hp-cloud/html/logsetting/logDetail.html', complexity: 'B', migrated: true, quality: 'auto', module: 'logsetting' },
  'logsetting/query': { key: 'logsetting/query', title: '日志设置 · 列表查询', routePath: '/logsetting/query', legacyPath: '/hp-cloud/html/logsetting/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'logsetting' },
  'articlemanage/edit': { key: 'articlemanage/edit', title: '文章管理 · 新增/编辑', routePath: '/articlemanage/edit', legacyPath: '/hp-cloud/html/articlemanage/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'articlemanage' },
  'articlemanage/preview': { key: 'articlemanage/preview', title: '文章管理 · preview', routePath: '/articlemanage/preview', legacyPath: '/hp-cloud/html/articlemanage/preview.html', complexity: 'A', migrated: true, quality: 'auto', module: 'articlemanage' },
  'articlemanage/query': { key: 'articlemanage/query', title: '文章管理 · 列表查询', routePath: '/articlemanage/query', legacyPath: '/hp-cloud/html/articlemanage/query.html', complexity: 'B', migrated: true, quality: 'auto', module: 'articlemanage' },
  'couponmanage/query': { key: 'couponmanage/query', title: '华鹏充电桩运营平台', routePath: '/couponmanage/query', legacyPath: '/hp-cloud/html/couponmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'couponmanage' },
  'couponmanage/queryCoupon': { key: 'couponmanage/queryCoupon', title: '优惠券管理 · queryCoupon', routePath: '/couponmanage/queryCoupon', legacyPath: '/hp-cloud/html/couponmanage/queryCoupon.html', complexity: 'A', migrated: true, quality: 'auto', module: 'couponmanage' },
  'couponmanage/receivingRecords': { key: 'couponmanage/receivingRecords', title: '优惠券管理 · 持有者用户名', routePath: '/couponmanage/receivingRecords', legacyPath: '/hp-cloud/html/couponmanage/receivingRecords.html', complexity: 'A', migrated: true, quality: 'auto', module: 'couponmanage' },
  'couponmanage/sendCoupon': { key: 'couponmanage/sendCoupon', title: '优惠券管理 · sendCoupon', routePath: '/couponmanage/sendCoupon', legacyPath: '/hp-cloud/html/couponmanage/sendCoupon.html', complexity: 'A', migrated: true, quality: 'auto', module: 'couponmanage' },
  'rolemanage/edit': { key: 'rolemanage/edit', title: '角色管理 · 新增/编辑', routePath: '/rolemanage/edit', legacyPath: '/hp-cloud/html/rolemanage/edit.html', complexity: 'A', migrated: true, quality: 'done', module: 'rolemanage' },
  'rolemanage/query': { key: 'rolemanage/query', title: '角色管理 · 列表查询', routePath: '/rolemanage/query', legacyPath: '/hp-cloud/html/rolemanage/query.html', complexity: 'A', migrated: true, quality: 'done', module: 'rolemanage' },
  'rolemanage/queryResource': { key: 'rolemanage/queryResource', title: '角色管理 · 资源授权', routePath: '/rolemanage/queryResource', legacyPath: '/hp-cloud/html/rolemanage/queryResource.html', complexity: 'A', migrated: true, quality: 'done', module: 'rolemanage' },
  'rolemanage/queryUserRole': { key: 'rolemanage/queryUserRole', title: '角色管理 · 用户角色', routePath: '/rolemanage/queryUserRole', legacyPath: '/hp-cloud/html/rolemanage/queryUserRole.html', complexity: 'A', migrated: true, quality: 'done', module: 'rolemanage' },
  'advermanage/edit': { key: 'advermanage/edit', title: '广告管理 · 新增/编辑', routePath: '/advermanage/edit', legacyPath: '/hp-cloud/html/advermanage/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'advermanage' },
  'advermanage/preview': { key: 'advermanage/preview', title: '广告管理 · preview', routePath: '/advermanage/preview', legacyPath: '/hp-cloud/html/advermanage/preview.html', complexity: 'A', migrated: true, quality: 'frame', module: 'advermanage' },
  'advermanage/query': { key: 'advermanage/query', title: '广告管理 · 列表查询', routePath: '/advermanage/query', legacyPath: '/hp-cloud/html/advermanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'advermanage' },
  'programmanage/edit': { key: 'programmanage/edit', title: '程序管理 · 新增/编辑', routePath: '/programmanage/edit', legacyPath: '/hp-cloud/html/programmanage/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'programmanage' },
  'programmanage/query': { key: 'programmanage/query', title: '程序管理 · 列表查询', routePath: '/programmanage/query', legacyPath: '/hp-cloud/html/programmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'programmanage' },
  'integratedpanel/show': { key: 'integratedpanel/show', title: '综合面板', routePath: '/integratedpanel/show', legacyPath: '/hp-cloud/html/integratedpanel/show.html', complexity: 'B', migrated: true, quality: 'frame', module: 'integratedpanel' },
  'faultrulemanage/edit': { key: 'faultrulemanage/edit', title: '故障规则 · 新增/编辑', routePath: '/faultrulemanage/edit', legacyPath: '/hp-cloud/html/faultrulemanage/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'faultrulemanage' },
  'faultrulemanage/query': { key: 'faultrulemanage/query', title: '故障规则 · 列表查询', routePath: '/faultrulemanage/query', legacyPath: '/hp-cloud/html/faultrulemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultrulemanage' },
  'thirdpartyuser/edit': { key: 'thirdpartyuser/edit', title: '第三方用户 · 新增/编辑', routePath: '/thirdpartyuser/edit', legacyPath: '/hp-cloud/html/thirdpartyuser/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'thirdpartyuser' },
  'thirdpartyuser/query': { key: 'thirdpartyuser/query', title: '第三方用户 · 列表查询', routePath: '/thirdpartyuser/query', legacyPath: '/hp-cloud/html/thirdpartyuser/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'thirdpartyuser' },
  'billmanage/edit': { key: 'billmanage/edit', title: '账单管理 · 新增/编辑', routePath: '/billmanage/edit', legacyPath: '/hp-cloud/html/billmanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billmanage' },
  'billmanage/query': { key: 'billmanage/query', title: '账单管理 · 列表查询', routePath: '/billmanage/query', legacyPath: '/hp-cloud/html/billmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billmanage' },
  'billmanage/updatePrice': { key: 'billmanage/updatePrice', title: '账单管理 · updatePrice', routePath: '/billmanage/updatePrice', legacyPath: '/hp-cloud/html/billmanage/updatePrice.html', complexity: 'A', migrated: true, quality: 'auto', module: 'billmanage' },
  'carbrand/edit': { key: 'carbrand/edit', title: '车辆品牌 · 新增/编辑', routePath: '/carbrand/edit', legacyPath: '/hp-cloud/html/carbrand/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'carbrand' },
  'carbrand/query': { key: 'carbrand/query', title: '车辆品牌 · 列表查询', routePath: '/carbrand/query', legacyPath: '/hp-cloud/html/carbrand/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'carbrand' },
  'paramsSetting/edit': { key: 'paramsSetting/edit', title: '参数设置 · 新增/编辑', routePath: '/paramsSetting/edit', legacyPath: '/hp-cloud/html/paramsSetting/edit.html', complexity: 'B', migrated: true, quality: 'auto', module: 'paramsSetting' },
  'logmanage/logDetail': { key: 'logmanage/logDetail', title: '日志管理 · 字段', routePath: '/logmanage/logDetail', legacyPath: '/hp-cloud/html/logmanage/logDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'logmanage' },
  'logmanage/query': { key: 'logmanage/query', title: '日志管理 · 列表查询', routePath: '/logmanage/query', legacyPath: '/hp-cloud/html/logmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'logmanage' },
  'faultworkordermanage/orderdetail': { key: 'faultworkordermanage/orderdetail', title: '故障工单 · 工单编号', routePath: '/faultworkordermanage/orderdetail', legacyPath: '/hp-cloud/html/faultworkordermanage/orderdetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultworkordermanage' },
  'faultworkordermanage/query': { key: 'faultworkordermanage/query', title: '故障工单 · 列表查询', routePath: '/faultworkordermanage/query', legacyPath: '/hp-cloud/html/faultworkordermanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultworkordermanage' },
  'faultworkordermanage/queryLog': { key: 'faultworkordermanage/queryLog', title: '故障履历', routePath: '/faultworkordermanage/queryLog', legacyPath: '/hp-cloud/html/faultworkordermanage/queryLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'faultworkordermanage' },
  'menumanage/edit': { key: 'menumanage/edit', title: '菜单管理 · 新增/编辑', routePath: '/menumanage/edit', legacyPath: '/hp-cloud/html/menumanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'menumanage' },
  'menumanage/query': { key: 'menumanage/query', title: '菜单管理 · 列表查询', routePath: '/menumanage/query', legacyPath: '/hp-cloud/html/menumanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'menumanage' },
  'appid/addAppId': { key: 'appid/addAppId', title: '应用ID管理 · addAppId', routePath: '/appid/addAppId', legacyPath: '/hp-cloud/html/appid/addAppId.html', complexity: 'A', migrated: true, quality: 'auto', module: 'appid' },
  'appid/apiLog': { key: 'appid/apiLog', title: '应用ID管理 · 请求开始时间', routePath: '/appid/apiLog', legacyPath: '/hp-cloud/html/appid/apiLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'appid' },
  'appid/appGroup': { key: 'appid/appGroup', title: '应用ID管理 · appGroup', routePath: '/appid/appGroup', legacyPath: '/hp-cloud/html/appid/appGroup.html', complexity: 'A', migrated: true, quality: 'frame', module: 'appid' },
  'appid/appIdManager': { key: 'appid/appIdManager', title: '华鹏充电桩运营平台', routePath: '/appid/appIdManager', legacyPath: '/hp-cloud/html/appid/appIdManager.html', complexity: 'A', migrated: true, quality: 'auto', module: 'appid' },
  'unicomuser/edit': { key: 'unicomuser/edit', title: '联通用户 · 新增/编辑', routePath: '/unicomuser/edit', legacyPath: '/hp-cloud/html/unicomuser/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'unicomuser' },
  'unicomuser/query': { key: 'unicomuser/query', title: '联通用户 · 列表查询', routePath: '/unicomuser/query', legacyPath: '/hp-cloud/html/unicomuser/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'unicomuser' },
  'secretkeymanager/list': { key: 'secretkeymanager/list', title: '密钥管理 · 列表', routePath: '/secretkeymanager/list', legacyPath: '/hp-cloud/html/secretkeymanager/list.html', complexity: 'B', migrated: true, quality: 'frame', module: 'secretkeymanager' },
  'accumulatemanage/editAccumulate': { key: 'accumulatemanage/editAccumulate', title: '累积量管理 · editAccumulate', routePath: '/accumulatemanage/editAccumulate', legacyPath: '/hp-cloud/html/accumulatemanage/editAccumulate.html', complexity: 'A', migrated: true, quality: 'auto', module: 'accumulatemanage' },
  'accumulatemanage/query': { key: 'accumulatemanage/query', title: '华鹏充电桩运营平台', routePath: '/accumulatemanage/query', legacyPath: '/hp-cloud/html/accumulatemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'accumulatemanage' },
  'userworkermanage/edit': { key: 'userworkermanage/edit', title: '运维人员 · 新增/编辑', routePath: '/userworkermanage/edit', legacyPath: '/hp-cloud/html/userworkermanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'userworkermanage' },
  'userworkermanage/query': { key: 'userworkermanage/query', title: '运维人员 · 列表查询', routePath: '/userworkermanage/query', legacyPath: '/hp-cloud/html/userworkermanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'userworkermanage' },
  'manufacturer/edit': { key: 'manufacturer/edit', title: '厂商管理 · 新增/编辑', routePath: '/manufacturer/edit', legacyPath: '/hp-cloud/html/manufacturer/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'manufacturer' },
  'manufacturer/query': { key: 'manufacturer/query', title: '厂商管理 · 列表查询', routePath: '/manufacturer/query', legacyPath: '/hp-cloud/html/manufacturer/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'manufacturer' },
  'batchstatistics/query': { key: 'batchstatistics/query', title: '华鹏充电桩运营平台', routePath: '/batchstatistics/query', legacyPath: '/hp-cloud/html/batchstatistics/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'batchstatistics' },
  'batchstatistics/queryDetail': { key: 'batchstatistics/queryDetail', title: '批量统计 · 明细查询', routePath: '/batchstatistics/queryDetail', legacyPath: '/hp-cloud/html/batchstatistics/queryDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'batchstatistics' },
  'invoicemanage/edit': { key: 'invoicemanage/edit', title: '发票管理 · 新增/编辑', routePath: '/invoicemanage/edit', legacyPath: '/hp-cloud/html/invoicemanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'invoicemanage' },
  'invoicemanage/import': { key: 'invoicemanage/import', title: '发票管理 · import', routePath: '/invoicemanage/import', legacyPath: '/hp-cloud/html/invoicemanage/import.html', complexity: 'A', migrated: true, quality: 'auto', module: 'invoicemanage' },
  'invoicemanage/query': { key: 'invoicemanage/query', title: '发票管理 · 列表查询', routePath: '/invoicemanage/query', legacyPath: '/hp-cloud/html/invoicemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'invoicemanage' },
  'messagetemplatemanage/edit': { key: 'messagetemplatemanage/edit', title: '消息模板 · 新增/编辑', routePath: '/messagetemplatemanage/edit', legacyPath: '/hp-cloud/html/messagetemplatemanage/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'messagetemplatemanage' },
  'messagetemplatemanage/preview': { key: 'messagetemplatemanage/preview', title: '消息模板 · preview', routePath: '/messagetemplatemanage/preview', legacyPath: '/hp-cloud/html/messagetemplatemanage/preview.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagetemplatemanage' },
  'messagetemplatemanage/query': { key: 'messagetemplatemanage/query', title: '消息模板 · 列表查询', routePath: '/messagetemplatemanage/query', legacyPath: '/hp-cloud/html/messagetemplatemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'messagetemplatemanage' },
  'balancemanager/query': { key: 'balancemanager/query', title: '余额管理 · 列表查询', routePath: '/balancemanager/query', legacyPath: '/hp-cloud/html/balancemanager/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'balancemanager' },
  'balancemanager/refundDetail': { key: 'balancemanager/refundDetail', title: '余额管理 · refundDetail', routePath: '/balancemanager/refundDetail', legacyPath: '/hp-cloud/html/balancemanager/refundDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'balancemanager' },
  'pilemeterspower/query': { key: 'pilemeterspower/query', title: '电表功率 · 列表查询', routePath: '/pilemeterspower/query', legacyPath: '/hp-cloud/html/pilemeterspower/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilemeterspower' },
  'pilemeterspower/queryDetail': { key: 'pilemeterspower/queryDetail', title: '订单履历', routePath: '/pilemeterspower/queryDetail', legacyPath: '/hp-cloud/html/pilemeterspower/queryDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pilemeterspower' },
  'pileapplication/query': { key: 'pileapplication/query', title: '充电桩申请 · 列表查询', routePath: '/pileapplication/query', legacyPath: '/hp-cloud/html/pileapplication/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'pileapplication' },
  'bookingmanage/query': { key: 'bookingmanage/query', title: '预约管理 · 列表查询', routePath: '/bookingmanage/query', legacyPath: '/hp-cloud/html/bookingmanage/query.html', complexity: 'B', migrated: true, quality: 'auto', module: 'bookingmanage' },
  'bookingmanage/queryLog': { key: 'bookingmanage/queryLog', title: '订单履历', routePath: '/bookingmanage/queryLog', legacyPath: '/hp-cloud/html/bookingmanage/queryLog.html', complexity: 'A', migrated: true, quality: 'auto', module: 'bookingmanage' },
  'wxpushlogmanage/findDetail': { key: 'wxpushlogmanage/findDetail', title: '微信推送日志 · findDetail', routePath: '/wxpushlogmanage/findDetail', legacyPath: '/hp-cloud/html/wxpushlogmanage/findDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'wxpushlogmanage' },
  'wxpushlogmanage/query': { key: 'wxpushlogmanage/query', title: '微信推送日志 · 列表查询', routePath: '/wxpushlogmanage/query', legacyPath: '/hp-cloud/html/wxpushlogmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'wxpushlogmanage' },
  'transfermanage/query': { key: 'transfermanage/query', title: '转账管理 · 列表查询', routePath: '/transfermanage/query', legacyPath: '/hp-cloud/html/transfermanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'transfermanage' },
  'transfermanage/queryDetail': { key: 'transfermanage/queryDetail', title: '转账管理 · 明细查询', routePath: '/transfermanage/queryDetail', legacyPath: '/hp-cloud/html/transfermanage/queryDetail.html', complexity: 'A', migrated: true, quality: 'auto', module: 'transfermanage' },
  'reportfaultmanage/dealFault': { key: 'reportfaultmanage/dealFault', title: '故障上报 · dealFault', routePath: '/reportfaultmanage/dealFault', legacyPath: '/hp-cloud/html/reportfaultmanage/dealFault.html', complexity: 'A', migrated: true, quality: 'auto', module: 'reportfaultmanage' },
  'reportfaultmanage/query': { key: 'reportfaultmanage/query', title: '故障上报 · 列表查询', routePath: '/reportfaultmanage/query', legacyPath: '/hp-cloud/html/reportfaultmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'reportfaultmanage' },
  'carmanage/carStatistics': { key: 'carmanage/carStatistics', title: '华鹏充电桩运营平台', routePath: '/carmanage/carStatistics', legacyPath: '/hp-cloud/html/carmanage/carStatistics.html', complexity: 'A', migrated: true, quality: 'auto', module: 'carmanage' },
  'carmanage/editCar': { key: 'carmanage/editCar', title: '车辆管理 · editCar', routePath: '/carmanage/editCar', legacyPath: '/hp-cloud/html/carmanage/editCar.html', complexity: 'A', migrated: true, quality: 'auto', module: 'carmanage' },
  'carmanage/query': { key: 'carmanage/query', title: '华鹏充电桩运营平台', routePath: '/carmanage/query', legacyPath: '/hp-cloud/html/carmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'carmanage' },
  'banksmanager/edit': { key: 'banksmanager/edit', title: '银行管理 · 新增/编辑', routePath: '/banksmanager/edit', legacyPath: '/hp-cloud/html/banksmanager/edit.html', complexity: 'A', migrated: true, quality: 'done', module: 'banksmanager' },
  'banksmanager/query': { key: 'banksmanager/query', title: '银行管理 · 列表查询', routePath: '/banksmanager/query', legacyPath: '/hp-cloud/html/banksmanager/query.html', complexity: 'A', migrated: true, quality: 'done', module: 'banksmanager' },
  'resourcemanage/edit': { key: 'resourcemanage/edit', title: '资源管理 · 新增/编辑', routePath: '/resourcemanage/edit', legacyPath: '/hp-cloud/html/resourcemanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'resourcemanage' },
  'resourcemanage/query': { key: 'resourcemanage/query', title: '资源管理 · 列表查询', routePath: '/resourcemanage/query', legacyPath: '/hp-cloud/html/resourcemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'resourcemanage' },
  'appraisemanage/query': { key: 'appraisemanage/query', title: '评价管理 · 列表查询', routePath: '/appraisemanage/query', legacyPath: '/hp-cloud/html/appraisemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'appraisemanage' },
  'appraisemanage/view': { key: 'appraisemanage/view', title: '评价管理 · 查看', routePath: '/appraisemanage/view', legacyPath: '/hp-cloud/html/appraisemanage/view.html', complexity: 'A', migrated: true, quality: 'auto', module: 'appraisemanage' },
  'appsettingmanage/edit': { key: 'appsettingmanage/edit', title: '应用设置 · 新增/编辑', routePath: '/appsettingmanage/edit', legacyPath: '/hp-cloud/html/appsettingmanage/edit.html', complexity: 'C', migrated: true, quality: 'auto', module: 'appsettingmanage' },
  'appsettingmanage/query': { key: 'appsettingmanage/query', title: '应用设置 · 列表查询', routePath: '/appsettingmanage/query', legacyPath: '/hp-cloud/html/appsettingmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'appsettingmanage' },
  'appsettingmanage/query2': { key: 'appsettingmanage/query2', title: '应用设置 · 名称', routePath: '/appsettingmanage/query2', legacyPath: '/hp-cloud/html/appsettingmanage/query2.html', complexity: 'A', migrated: true, quality: 'frame', module: 'appsettingmanage' },
  'modulemanage/edit': { key: 'modulemanage/edit', title: '模块管理 · 新增/编辑', routePath: '/modulemanage/edit', legacyPath: '/hp-cloud/html/modulemanage/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'modulemanage' },
  'modulemanage/query': { key: 'modulemanage/query', title: '模块管理 · 列表查询', routePath: '/modulemanage/query', legacyPath: '/hp-cloud/html/modulemanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'modulemanage' },
  'rateplanmanage/query': { key: 'rateplanmanage/query', title: '费率方案 · 列表查询', routePath: '/rateplanmanage/query', legacyPath: '/hp-cloud/html/rateplanmanage/query.html', complexity: 'A', migrated: true, quality: 'auto', module: 'rateplanmanage' },
  'eneryctlparams/edit': { key: 'eneryctlparams/edit', title: '能源控制参数 · 新增/编辑', routePath: '/eneryctlparams/edit', legacyPath: '/hp-cloud/html/eneryctlparams/edit.html', complexity: 'A', migrated: true, quality: 'auto', module: 'eneryctlparams' },
  'commpop/pwdChk': { key: 'commpop/pwdChk', title: '通用弹窗 · pwdChk', routePath: '/commpop/pwdChk', legacyPath: '/hp-cloud/html/commpop/pwdChk.html', complexity: 'A', migrated: true, quality: 'auto', module: 'commpop' },
}

export const migrationStats = {
  total: 269,
  migrated: 267,
  done: 10,
  auto: 215,
  frame: 42,
  byComplexity: {"A":179,"B":52,"C":38},
  apiCount: 540,
  totalLegacyLines: 96952
}
